const translations = {
  language: "Sprache",
  login: {
    welcome: "Willkommen",
    ssoLogin: "Mit deiner Konto-E-Mail anmelden",
    detailsGeneric: "Details",
    customers: "Endnutzer",
    sendEmail: "E-Mail senden",
    otpLogin: "Anmelden per E-Mail",
    login: "Anmelden",
    changeEmail: "Andere E-Mail-Adresse verwenden",
    or: "ODER",
    dontHaveAccount: "Kein Konto?",
    requestAccess: "Zugriff anfordern",
    accessRequestTitle: "Zugriff anfordern",
  },
  domains: {
    customerAdminDeletionConfirm: "Möchten Sie diesen Endnutzer löschen? Dieser Vorgang kann nicht rückgängig gemacht werden",
    customerAdminDeletionSuccess: "Endnutzer erfolgreich gelöscht",
    luckeyDomainsTitle: "Domains",
    domainName: "Domain-Name",
    domainDetails: "Domain-Details",
    domainConfigModifySuccess: "Domain-Konfiguration erfolgreich geändert und aktualisiert",
    domainConfigTitle: "Konfigurationen - Feature-Toggling",
    domainConfigDescription: "Domain-Konfiguration im JSON-Format. Verwenden Sie diese, um Domain-Funktionen zu aktivieren oder zu deaktivieren",
    domainConfigGuide: "Domain-Konfigurationsleitfaden",
    noUsersFoundTitle: "Benutzerliste leer",
    domainUsersTitle: "Domain-Manager",
    domainUsersDescription: "Imitiere einen der Benutzer-Manager für Wartungsoperationen in der Domain",
    domainUsersWarning: "ACHTUNG: Durch das Imitieren von Benutzern können Änderungen am System vorgenommen werden, auch irreversible. Bitte höchste Vorsicht walten lassen",
    noUsersFoundDescription: "Für diese Domain wurden keine Benutzer gefunden",
    noDomainsFoundTitle: "Keine Domains gefunden",
    noDomainFoundDescription: "Die Domain-Liste ist leer. Falls ein Suchfilter gesetzt ist, versuchen Sie diesen zurückzusetzen und erneut zu suchen",
    impersonateSuccess: "Benutzer-Imitation erfolgreich",
    domainSubsriptionTitle: "Domain-Abonnement",
    domainSubsriptionDescription: "Liste der Domain-Abonnements: Schlösser, Benutzer und Domain-Ablauf",
    expiration: "Ablauf",
    totalNumber: "Gesamtzahl",
    used: "Verwendete Elemente",
    tooMuchElements: "WARNUNG: DIE DOMAIN HAT DIE GESAMTANZAHL DER ELEMENTE ÜBERSCHRITTEN",
    newDomain: "Neue Domain",
    externalReference: "Externe Referenz",
    externalReferenceDetails: "Zum Beispiel \"date-purchaseId\"",
    productDescription: "Das Produkt repräsentiert die Lizenz, die für die neue Domain aktiviert wird",
    productTitle: "Abonnement-Typ",
    extendDomain: "Domain-Abonnement erweitern",
    extendDomainDescription: "Erweitern Sie Ihre Domain mit einem Add-on oder Produkt-Key",
    domainInstallersTitle: "Domain-Installer",
    domainInstallersDescription: "Liste der Installer-Benutzer auf den ausgewählten Standorten",
    domainDeletionTitle: "Domain löschen",
    domainDeletionDescription: "Senden Sie eine Anfrage, um diese Domain zu löschen",
    sendDeletionRequest: "Senden",
    domainDeletionConfirm: "Möchten Sie eine Anfrage zum Löschen dieser Domain senden?",
    domainDeletionSuccess: "Anfrage erfolgreich gesendet",
    customerDeletionTitle: "Endnutzer löschen",
    customerDeletionConfirm: "Möchten Sie eine Anfrage zum Löschen dieses Endnutzers senden?",
    customerDeletionSuccess: "Anfrage erfolgreich gesendet",
    walletDeletionTitle: "Wallet löschen",
    walletDeletionConfirm: "Möchten Sie eine Anfrage zum Löschen dieses Wallets senden?",
    walletDeletionSuccess: "Anfrage erfolgreich gesendet",
    verifyServiceStatus: "Service-Status",
    impersonateUser: "Benutzer imitieren",
    impersonate: "Imitieren",
    impersonateReadOnly: "Imitieren im Nur-Lesen-Modus",
    domainAdditionalInfo: "Domain-Informationen",
    domainAdditionalInfoDescription: "Zusätzliche Domain-Informationen hier angeben",
    additionalInfoSavedSuccessfully: "Zusätzliche Notizen erfolgreich gespeichert",
    EASY: "Nur Argo Locks",
    SMART: "Argo Locks + Gateway",
    ENTERPRISE: "V364 + Argo Locks",
    STANDARD: "Nur V364 Locks",
    numberOfArgoLocks: "Argo",
    numberOfVegaLocks: "V364",
    numberOfGatewaysLocks: "Gateways",
    numberOfUsers: "Benutzer",
    numberOfLocks: "Smart Locks",
    federatedDomain: "Domain verbunden mit: {{domain}}",
    federatedMasterDomain: "Hauptdomain einer Gruppe",
    domainFederatedLicense: "Föderiertes Standort-Abonnement: Dieses Abonnement ist für alle Domains, die zur Hauptdomain {{domain}} gehören, einheitlich",
    federatedDomains: "Domain-Gruppe",
    federatedDomainsDescription: "Domain gehört zu einer Gruppe",
    installationMode: "Installationsmodus",
    domainStandard: "Alte Domain",
    domainWithCloudCredits: "Domain mit Cloud-Guthaben",
    domainIrisRequired: "1RIS erforderlich",
    domainIrisEnabled: "1RIS aktiviert",
    domainIrisEnable: "1RIS aktivieren",
    domainIrisEnableConfirm: "Möchten Sie 1RIS für diese Domain als AKTIV setzen?",
    editPlantDetails: "Anlagendetails bearbeiten",
    editPlantDetailsSuccess: "Anlagendetails erfolgreich aktualisiert",
    zenDeskId: "ZenDesk Id",
    lockbaseId: "Lockbase Id",
    license1ris: "1RIS Lizenz",
    domainsWithCloudCredits: "Domains mit Cloud-Guthaben",
    domainsLegacy: "Alte Domains",
    domainSecretsTitle: "Domain-Geheimnisse",
    domainSecretsDescription: "Auf dieser Domain gespeicherte Zugangsdaten, entschlüsselt angezeigt",
    domainSecretsEmpty: "Für diese Domain sind keine Geheimnisse gespeichert",
    domainSecretsError: "Domain-Geheimnisse konnten nicht geladen werden",
    domainSecretsYes: "Ja",
    domainSecretsNo: "Nein",
    domainSecretsCopied: "Kopiert",
    domainSecretsKey: "Schlüssel",
    domainSecretsValue: "Wert",
    domainSecretsAdd: "Schlüssel hinzufügen",
    domainSecretsEdit: "Bearbeiten",
    domainSecretsFieldType: "Feldtyp",
    domainSecretsFieldTypeText: "Text",
    domainSecretsFieldTypePassword: "Passwort",
    domainSecretsFieldTypeUrl: "URL",
    domainSecretsFieldTypeBoolean: "Ja / Nein",
    domainSecretsShowPassword: "Wert anzeigen",
    domainSecretsHidePassword: "Wert ausblenden",
    domainSecretsDelete: "Feld löschen",
    domainSecretsDeleteConfirm: "Feld \"{{key}}\" entfernen?",
    domainSecretsSaveError: "Domain-Geheimnisse konnten nicht gespeichert werden",
    domainAppConfigurationTitle: 'Benutzerdefinierte Login-Prüfung',
    domainAppConfigurationDescription: 'HTTPS-Endpunkte zur E-Mail-Prüfung beim Login',
    domainAppConfigurationUrlsLabel: 'Prüf-URLs',
    domainAppConfigurationUrlsHint: 'Eine HTTPS-URL pro Zeile. {placeholder} für ein Pfadsegment. Leer lassen, um die Konfiguration zu löschen.',
    domainAppConfigurationFieldsLabel: 'E-Mail-Felder in der Antwort',
    domainAppConfigurationFieldsHint: 'Ein JSON-Feldname pro Zeile (z. B. email). Erforderlich, wenn URLs gesetzt sind.',
    domainAppConfigurationLoadError: 'App-Konfiguration konnte nicht geladen werden',
    domainAppConfigurationSaveError: 'App-Konfiguration konnte nicht gespeichert werden',
    domainAppConfigurationInvalidUrl: 'Eine oder mehrere URLs sind ungültig (HTTPS erforderlich, keine IP oder localhost)',
    domainAppConfigurationFieldsRequired: 'Mindestens ein E-Mail-Feld ist erforderlich, wenn Prüf-URLs konfiguriert sind',
  },
  credits: {
    pricelistImport: 'Preisliste importieren',
    pricelistImportTitle: 'Preisliste importieren',
    pricelistChooseFile: 'Datei wählen (.xlsx, .xls, .csv)',
    pricelistChooseAnotherFile: 'Andere Datei wählen',
    pricelistDownloadTemplate: 'Vorlage herunterladen',
    pricelistSheet: 'Tabellenblatt',
    pricelistCompany: 'Unternehmen',
    pricelistSelectCompany: 'Wählen Sie das Unternehmen, dessen Zeilen importiert werden sollen',
    pricelistError: 'Fehler beim Import der Preisliste: {{message}}',
    pricelistStatus_NEW: 'Neu',
    pricelistStatus_CHANGED: 'Geändert',
    pricelistStatus_READONLY_CHANGED: 'Nicht änderbare Unterschiede',
    pricelistStatus_UNCHANGED: 'Unverändert',
    pricelistStatus_ERROR: 'Fehler',
    pricelistStatus_SKIPPED: 'Übersprungen',
    pricelistFilterAll: 'Alle',
    pricelistColumnRow: 'Zeile',
    pricelistColumnMainTier: 'Main Tier',
    pricelistColumnStatus: 'Status',
    pricelistColumnDetails: 'Details',
    pricelistOnlyInBackend: '{{count}} bestehende Abonnements sind nicht in der Datei und bleiben unverändert',
    pricelistParseErrors: 'Zeilen mit Fehlern ({{count}}), sie werden übersprungen',
    pricelistRowError: 'Zeile {{row}} ({{sku}}): {{message}}',
    pricelistShowingFirst: 'Die ersten {{count}} von {{total}} Zeilen werden angezeigt',
    pricelistNoRows: 'Keine Zeilen für diesen Filter',
    pricelistApply: '{{count}} Änderungen anwenden',
    pricelistApplyTitle: 'Preisliste anwenden',
    pricelistApplyConfirm: 'Es werden {{created}} Abonnements dieses Marktplatzes erstellt und {{updated}} aktualisiert. Möchten Sie fortfahren?',
    pricelistApplyConfirmWithErrors: 'Es werden {{created}} Abonnements dieses Marktplatzes erstellt und {{updated}} aktualisiert. {{errors}} Zeilen mit Fehlern werden übersprungen. Möchten Sie fortfahren?',
    pricelistApplying: 'Änderungen werden angewendet: {{done}} / {{total}}',
    pricelistResultSummary: 'Erstellt: {{created}} - Aktualisiert: {{updated}} - Fehlgeschlagen: {{failed}}',
    pricelistFailedItem: '{{sku}} (Main Tier: {{tier}}): {{message}}',
    customerPlantLockbaseId: 'Lockbase ID',
    customerPlantName: 'Name des Standorts',
    defaultMarketplace: 'Standard',
    setMarketplaceAsDefault: 'Als Standard setzen',
    marketplaceSetAsDefaultConfirm: 'Möchten Sie diesen Marktplatz als Standard setzen?',
    marketplaceSetAsDefaultError: 'Fehler beim Setzen des Marktplatzes als Standard',
    notificationStartDate: 'Benachrichtigungsstartdatum',
    notificationAssociatedServices: 'Zugeordnete Dienstleistungen (optional)',
    notificationAssociatedServicesHelp: 'Wählen Sie eine oder mehrere Dienstleistungen aus, die mit dieser Benachrichtigung verknüpft werden sollen. Lassen Sie dieses Feld leer, um allgemeine Vertragsbenachrichtigungen zu erstellen.',
    selectContractServices: 'Dienstleistungen auswählen',
    notificationPeriodicMode: 'Zeitplanmodus',
    notificationPeriodicModeStartDate: 'Start vom bestimmten Datum',
    notificationPeriodicModeDayOfMonth: 'Start vom bestimmten Tag des Monats',
    contractServicePrice: 'Preis',
    contractServiceOriginalPrice: 'Originalpreis',
    contractServiceCurrency: 'Währung',
    notificationRuleFormTitle: 'Vertragsbenachrichtigungsregel',
    notificationRuleType: 'Benachrichtigungstyp',
    notificationRuleType_ONCE: 'Einmalig',
    notificationRuleType_PERIODIC: 'Wiederkehrend',
    notificationSpecificDate: 'Benachrichtigungsdatum',
    notificationIntervalMonths: 'Wiederholen alle',
    notificationDayOfMonth: 'Tag des Monats',
    notificationEmails: 'E-Mail-Adressen',
    notificationEmailsHelp: 'E-Mail-Adressen durch Kommas getrennt eingeben',
    notificationAssociatedService: 'Zugeordneter Service (optional)',
    notificationEnabled: 'Aktiviert',
    nextRun: 'Nächste Ausführung',
    schedule: 'Zeitplan',
    notificationIntervalMonths_1: 'Jeden Monat',
    notificationIntervalMonths_2: 'Alle 2 Monate',
    notificationIntervalMonths_3: 'Alle 3 Monate',
    notificationIntervalMonths_4: 'Alle 4 Monate',
    notificationIntervalMonths_6: 'Alle 6 Monate',
    notificationIntervalMonths_12: 'Jedes Jahr',
    newNotificationRule: 'Neue Benachrichtigung',
    editNotificationRule: 'Benachrichtigung bearbeiten',
    deleteNotificationRule: 'Benachrichtigung löschen',
    deleteNotificationRuleConfirm: 'Möchten Sie diese Benachrichtigung löschen?',
    notificationRuleCreationConfirm: 'Möchten Sie die neue Benachrichtigung erstellen?',
    notificationRuleEditConfirm: 'Sie sind dabei, die Benachrichtigung zu bearbeiten. Möchten Sie fortfahren?',
    noNotificationRulesFound: 'Keine Benachrichtigungen gefunden',
    noNotificationRulesDescription: 'Die Benachrichtigungsliste ist leer. Erstellen Sie eine neue Benachrichtigung, um zu beginnen.',
    selectContractService: 'Einen Service auswählen',
    noContractServicesFound: 'Keine Services für diesen Vertrag gefunden',
    noServiceSelected: 'Kein Service ausgewählt (allgemeine Benachrichtigung)',
    generalContractNotification: 'Allgemeine Vertragsbenachrichtigung',
    serviceSpecificNotification: 'Service-spezifische Benachrichtigung',
    andMoreEmails: 'und {{count}} weitere E-Mails',
    dayOfMonthValidationError: 'Der Tag muss zwischen 1 und 28 liegen',
    dayOfMonthHelp: 'Geben Sie einen Tag zwischen 1 und 28 ein',
    createCustomerContractNotificationRuleError: 'Fehler beim Erstellen der Benachrichtigung',
    editCustomerContractNotificationRuleError: 'Fehler beim Bearbeiten der Benachrichtigung',
    deleteCustomerContractNotificationRuleError: 'Fehler beim Löschen der Benachrichtigung',
    enterEmail: 'E-Mail-Adresse eingeben',
    domainsPeriodic: 'Periodische Domains',
    andMorePlants: 'und {{count}} weitere Domains',
    andMoreServices: 'und {{count}} weitere Dienstleistungen',
    customerContractSearch: 'Vertrag suchen',
    domainPeriodic: 'Periodische Domain',
    customerPlantHostname: 'Domain-URL',
    customerPlantSolution: 'Lösung',
    customerPlantManagement: 'Hosting Type',
    customerPlantModality: 'Modalität',
    customerPlantSubSegment: 'Subsegment',
    customerPlantZendesk: 'Zendesk-ID',
    customerPlantLoginData: 'Anmeldedaten',
    customerPlantLicense1ris: 'Seriennummer Lizenz',
    openZendesk: 'Zendesk öffnen',
    totalInvoicedWithExplanation: 'Total fakturiert (Nettopreis x Menge)',
    netPrice: 'Nettopreis',
    quantity: 'Menge',
    totalInvoiced: 'Total fakturiert',
    customerPlantPlatform: 'Platform',
    customerPlantPlatformIris: '1RIS',
    customerPlantPlatformIrisArgo: '1RIS + ARGO',
    customerPlantPlatformArgo: 'ARGO',
    customerPlantTypePreprodPilot: 'Preprod - Pilot',
    customerPlantTypePreprodProduction: 'Preprod - Production',
    customerPlantTypeProdPilot: 'Prod - Pilot',
    customerPlantTypeProdProduction: 'Prod - Production',
    customerPlantTypeProdDisabled: 'Prod - Disabled',
    customerPlantTypeDemo: 'Demo',
    customerPlantTypeDead: 'Dead',
    customerPlantType: 'Plant type',
    customerPlantSolutionLsa: 'LSA',
    customerPlantSolutionV364: 'V364',
    customerPlantSolutionV364Classic: 'V364 Classic',
    customerPlantSolutionLuckey: 'Luckey',
    customerPlantSolutionArgo: 'Argo',
    customerPlantSolutionFlex: 'Flex',
    customerPlantSolutionLwc: 'LWC',
    customerPlantSolutionAtg: 'ATG',
    customerPlantSolutionVar: 'VAR',
    customerPlantSolutionMechanic: 'Mechanic',
    customerPlantSolutionOther: 'Other',
    customerPlantManagementOnPremiseClassic: 'On Premise::Classic',
    customerPlantManagementOnPremiseVmNative: 'On Premise::VM Native',
    customerPlantManagementOnPremiseVmDockerBased: 'On Premise::VM Docker Based',
    customerPlantManagementOnPremiseContainer: 'On Premise::Container',
    customerPlantManagementOnPremiseOther: 'On Premise::Other',
    customerPlantManagementSaasAzure: 'SaaS::Azure',
    customerPlantManagementSaasAws: 'SaaS:AWS',
    customerPlantManagementOther: 'Other',
    customerPlantModalityPeriodic: 'Periodisch',
    customerPlantModalityCredits: 'Guthaben',
    createCustomerDomainError: 'Domain konnte nicht erstellt oder bearbeitet werden. Bitte überprüfen Sie die eingegebenen Daten und versuchen Sie es erneut',
    noCustomerDomainFindTitle: 'Keine Domains gefunden',
    noCustomerDomainFindDescription: 'Die Domainliste ist leer. Wenn Sie einen Suchfilter gesetzt haben, versuchen Sie ihn zurückzusetzen und erneut zu suchen',
    editCustomerDomain: 'Domain bearbeiten',
    editCustomerDomainConfirm: 'Sie sind dabei, die Domaindaten zu bearbeiten. Möchten Sie fortfahren?',
    newCustomerDomain: 'Neue Domain',
    customerDomainCreationConfirm: 'Möchten Sie die neue Domain erstellen?',
    deleteCustomerDomainError: 'Domain konnte nicht gelöscht werden. Bitte versuchen Sie es erneut',
    deleteCustomerDomainConfirm: 'Möchten Sie die Domain löschen?',
    customerContractActivationDate: 'Aktivierungsdatum',
    customerContractDeactivationDate: 'Deaktivierungsdatum',
    customerContractDetails: 'Vertragsdetails',
    contractServices: 'Dienstleistungen',
    contractService: 'Dienstleistung',
    contractDocuments: 'Dokumente',
    contractNotifications: 'Benachrichtigungen',
    deleteCustomerContract: 'Vertrag löschen',
    deleteCustomerContractConfirm: 'Möchten Sie den Vertrag löschen?',
    deleteCustomerContractError: 'Vertrag konnte nicht gelöscht werden. Bitte versuchen Sie es erneut',
    associateNewPlantToContract: 'Neue Domain zuordnen',
    addCustomerPlantMessage: 'Wählen Sie die Domain aus, die diesem Vertrag hinzugefügt werden soll',
    removeCustomerPlantFromContract: 'Entfernen',
    removeCustomerPlantFromContractConfirm: 'Möchten Sie die Domain aus dem Vertrag entfernen?',
    addCustomerPlantToContractError: 'Domain konnte nicht zum Vertrag hinzugefügt werden. Bitte versuchen Sie es erneut',
    removeCustomerPlantFromContractError: 'Domain konnte nicht aus dem Vertrag entfernt werden. Bitte versuchen Sie es erneut',
    customerContractStatus_ACTIVE: 'Aktiv',
    customerContractStatus_NOT_ACTIVE: 'Inaktiv',
    customerContractStatus_CANCELLED: 'Storniert',
    downloadDocument: 'Herunterladen',
    associateNewDocumentToContract: 'Dokument hinzufügen',
    addDocument: 'Dokument hinzufügen',
    addDocumentMessage: 'Wählen Sie das Dokument aus, das diesem Vertrag hinzugefügt werden soll',
    documentName: 'Dateiname',
    addDocumentToContractError: 'Dokument konnte nicht zum Vertrag hinzugefügt werden. Bitte versuchen Sie es erneut',
    deleteContractDocumentConfirm: 'Möchten Sie dieses Dokument löschen?',
    deleteContractDocumentError: 'Dokument konnte nicht gelöscht werden. Bitte versuchen Sie es erneut',
    noCustomerContractDocumentFindTitle: 'Keine Dokumente gefunden',
    noCustomerContractDocumentFindDescription: 'Die Dokumentenliste ist leer. Wenn Sie einen Suchfilter gesetzt haben, versuchen Sie ihn zurückzusetzen und erneut zu suchen',
    noCustomerContractServiceFindTitle: 'Keine Dienstleistungen gefunden',
    noCustomerContractServiceFindDescription: 'Die Dienstleistungsliste ist leer. Wenn Sie einen Suchfilter gesetzt haben, versuchen Sie ihn zurückzusetzen und erneut zu suchen',
    editCustomerContractService: 'Dienstleistung bearbeiten',
    editCustomerContractServiceConfirm: 'Sie sind dabei, die Dienstleistungsdaten zu bearbeiten. Möchten Sie fortfahren?',
    createCustomerContractServiceError: 'Dienstleistung konnte nicht erstellt werden. Bitte überprüfen Sie die eingegebenen Daten und versuchen Sie es erneut',
    deleteCustomerContractServiceError: 'Dienstleistung konnte nicht gelöscht werden. Bitte versuchen Sie es erneut',
    deleteCustomerContractServiceConfirm: 'Möchten Sie die Dienstleistung löschen?',
    newCustomerContractService: 'Neue Dienstleistung',
    customerContractServiceCreationConfirm: 'Möchten Sie die neue Dienstleistung erstellen?',
    customerContractServiceFormTitle: 'Kundenvertragsdienstleistung',
    duplicateCustomerContractServiceFormTitle: 'Kundenvertragsdienstleistung duplizieren',
    customerDomainFormTitle: 'Anlagen',
    manageDomainFromWallet: 'Sie können diese Domain von ihrer Wallet-Seite verwalten: {{walletName}}',
    selectService: 'Dienstleistung auswählen',
    noServicesFound: 'Keine Dienstleistungen gefunden',
    serviceSubject: 'Betreff',
    serviceGroupFamily: 'Gruppenfamilie',
    serviceType: 'Typ',
    searchContractService: 'Dienstleistung nach Code, Betreff, Gruppenfamilie suchen...',
    contractServiceCode: 'Code',
    customerServiceSelloutPONumber: 'Sell-out PO-Nummer',
    customerServiceSfdcId: 'SFDC-ID',
    customerContractServiceNotes: 'Notizen',
    customerContractServiceStatus: 'Status',
    customerContractServiceStatus_WAITING_FOR_ACTIVATION: 'Warten auf Aktivierung',
    customerContractServiceStatus_ACTIVE: 'Aktiv',
    customerContractServiceStatus_PAUSED: 'Pausiert',
    customerContractServiceStatus_CANCELLED: 'Storniert',
    customerContractServiceStatus_INACTIVE: 'Inaktiv',
    customerContractServiceStatus_WAITING_TO_BE_DONE: 'Warten auf Erledigung',
    customerContractServiceStatus_WORK_IN_PROGRESS: 'In Bearbeitung',
    customerContractServiceStatus_DONE: 'Erledigt',
    sfdcIdAndSelloutPo: 'SFDC-ID | Sell-out PO',
    groupFamilySubjectCode: 'Dienstleistung',
    activationDeactivationStatus: 'Status',
    noPlantsAssociated: 'Keine Domains zugeordnet',
    noServicesAssociated: 'Keine Dienstleistungen zugeordnet',
    loadingServices: 'Dienstleistungen werden geladen...',
    chooseFile: 'Datei auswählen',
    exportCustomerContractsCSV: 'CSV exportieren',
    exportCustomerContractsXLSX: 'Excel exportieren',
    exportCustomerContractsError: 'Fehler beim CSV-Export',
    exportCustomerContractServicesCSV: 'CSV exportieren',
    exportCustomerContractServicesError: 'Fehler beim CSV-Export',
    customerAndContract: 'Kunde | Vertrag',
    customerContract: 'Vertrag',
    customer: 'Kunde',
    customerContractServiceSearch: 'Dienstleistung suchen',
    customerContractName: 'Vertragsname',
    customerContractStatus: 'Vertragsstatus',
    customerContractSigningDate: 'Unterschrift am',
    customerContractExpirationDate: 'Ablauf am',
    marketplaces: "Marktplätze",
    searchMarketplace: "Marktplatz suchen...",
    marketplaceName: "Marktplatzname",
    luckeyMarketplaceTitle: "Luckey-Marktplätze",
    noMarketplaceFoundTitle: "Kein Marktplatz gefunden",
    noMarketplaceFoundDescription: "Die Marktplatzliste ist leer. Wenn Sie einen Suchfilter gesetzt haben, versuchen Sie diesen zurückzusetzen und erneut zu suchen",
    newMarketplace: "Neuer Marktplatz",
    marketplaceCreationConfirm: "Möchten Sie den neuen Marktplatz erstellen?",
    createMarketplace: "Marktplatz erstellen",
    marketplaceDetails: "Marktplatz-Details",
    editMarketplaceCreationConfirm: "Sie sind dabei, die Daten des Marktplatzes zu bearbeiten. Sind Sie sicher, dass Sie fortfahren möchten?",
    editMarketplace: "Marktplatz bearbeiten",
    searchCustomer: "Endnutzer suchen...",
    customerName: "Name des Endnutzers",
    luckeyCustomersTitle: "Luckey-Endnutzer",
    noCustomerFindTitle: "Kein Endnutzer gefunden",
    noCustomerFindDescription: "Die Endnutzerliste ist leer. Wenn Sie einen Suchfilter gesetzt haben, versuchen Sie diesen zurückzusetzen und erneut zu suchen",
    noCustomerContractFindTitle: 'Kein Service-Vertrag gefunden',
    noCustomerContractFindDescription: 'Die Liste der Service-Verträge ist leer. Wenn Sie einen Suchfilter gesetzt haben, versuchen Sie diesen zurückzusetzen und erneut zu suchen',
    newCustomer: "Neuer Endnutzer",
    customerCreationConfirm: "Möchten Sie den neuen Endnutzer erstellen?",
    newUser: "Neuer Benutzer",
    userCreationConfirm: "Möchten Sie den neuen Benutzer erstellen?",
    createCustomer: "Endnutzer erstellen",
    customerDetails: "Endnutzer-Details",
    editCreationConfirm: "Sie sind dabei, die Daten des Endnutzers zu bearbeiten. Sind Sie sicher, dass Sie fortfahren möchten?",
    editCustomer: "Endnutzer bearbeiten",
    editCreationUserConfirm: "Sie sind dabei, die Benutzerdaten zu bearbeiten. Sind Sie sicher, dass Sie fortfahren möchten?",
    editCustomerContract: 'Service-Vertrag bearbeiten',
    editCustomerContractConfirm: 'Sie sind dabei, die Service-Vertragsdaten zu bearbeiten. Sind Sie sicher, dass Sie fortfahren möchten?',
    newCustomerContract: 'Neuer Service-Vertrag',
    customerContractCreationConfirm: 'Möchten Sie den neuen Service-Vertrag erstellen?',
    editUser: "Benutzer bearbeiten",
    customerWallets: "Wallets von {{customerName}}",
    wallets: 'Wallets',
    contracts: 'Service-Verträge',
    plants: 'Plants',
    customerPlants: 'Impianten',
    newWallet: "Neues Wallet",
    walletCreationConfirm: "Möchten Sie ein neues Wallet für den ausgewählten Endnutzer erstellen?",
    createWallet: "Wallet erstellen",
    editWallet: "Wallet bearbeiten",
    walletEditConfirm: "Möchten Sie das ausgewählte Wallet bearbeiten?",
    noWalletFoundTitle: "Kein Wallet gefunden",
    noWalletFoundDescription: "Für den ausgewählten Endnutzer wurde kein Wallet gefunden",
    walletDetails: "Wallet-Details",
    rechargeWallet: "Aufladen",
    walletRechargeHistory: "Aufladehistorie",
    rechargeRowTitle: "Geänderte Credits",
    rechargeCreditsDescription: "Das Wallet wurde mit {{credits}} Credits aufgeladen",
    rechargeCardDetails: "Auflade-Details",
    systemParameters: "Preisliste",
    systemSubscriptions: "Abonnements",
    systemSubscriptionsDescription: "Dies sind die Abonnements im System. Erstellen Sie neue oder weisen Sie sie einer bestehenden Domain zu",
    newSubscription: "Neues Abonnement",
    editSubscription: "Abonnement bearbeiten",
    noSystemSubscriptionFoundTitle: "Kein Abonnement gefunden",
    noSystemSubscriptionFoundDescription: "Es gibt kein Systemabonnement, das einer Domain zugewiesen werden kann",
    products: "Alte Abonnements",
    rechargeCards: "Aufladekarten",
    noSystemCardFoundTitle: "Keine Aufladekarte gefunden",
    noSystemCardFoundDescription: "Es gibt keine Aufladekarten im System. Erstellen Sie neue, um die Wallets der Endnutzer aufzuladen",
    newCard: "Neue Aufladekarte",
    cardStatusUsed: "Verwendet",
    rechargeCardCreditsDetails: "Diese Aufladekarte hat einen Wert von {{credits}} Credits",
    cardStatusUnused: "Nicht verwendet",
    cardStatusInactive: "Deaktiviert",
    enableCard: "Aktivieren",
    disabledCardTooltip: "Die Aufladekarte wird aktiviert, sobald Sie die zugehörige ISEO-Rechnung erhalten",
    newTierSubscription: "Neues Hauptabonnement",
    pluginAndService: "Add-on und Services",
    newPluginSubscription: "Neues Add-on oder Service",
    tierSubscription: "Hauptabonnement",
    walletSubscriptions: "Abonnements",
    noWalletSubscriptionFoundTitle: "Kein Abonnement gefunden",
    noWalletSubscriptionFoundDescription: "Dieses Wallet hat kein zugeordnetes Abonnement",
    newWalletSubscription: "Neues Abonnement zuweisen",
    editWalletSubscription: "Abonnement bearbeiten",
    newWalletPluginSubscription: "Neues Add-on oder Service zuweisen",
    walletConsumption: "Verbrauch",
    noWalletUsageFoundTitle: "Keine Daten gefunden",
    noWalletUsageFoundDescription: "Es liegen keine Verbrauchsdaten für dieses Wallet vor",
    ACTIVATION: "Aktivierungskosten der Domain oder des Add-ons",
    DAILY_USAGE: "Täglicher Verbrauch",
    creditConsumptionType: "Verbrauchstyp",
    consumptionCreditsDescription: "Das Wallet hat {{credits}} verbraucht",
    consumptionRowTitle: "Wallet-Verbrauch",
    walletPlants: "Domains",
    noWalletPlantFoundTitle: "Keine Domain gefunden",
    noWalletPlantFoundDescription: "Es sind keine Domains diesem Wallet zugeordnet",
    newWalletPlant: "Neue Domain",
    deleteWalletSubscription: "Abonnement entfernen",
    editCard: "Aufladekarte bearbeiten",
    rechargeDetails: "Auflade-Details",
    exportWalletsUsageCSV: "CSV des Credit-Verbrauchs exportieren",
    exportWalletsCreditUsageCSV: "Wallet-Credit exportieren",
    PENDING: "Ausstehend",
    ACTIVE: "Aktiv",
    READY_TO_ACTIVATE: "Bereit zur Aktivierung",
    DISABLED: "Deaktiviert",
    walletStatus: "Wallet-Status",
    exportManagersCSV: "Manager exportieren",
    needCreditsToCreatePlant: "Sie benötigen Credits in diesem Wallet, um eine neue Domain zu erstellen"
  },
  sales: {
    hardwareSalesInfo: "Verkaufsinformationen",
    domain: "Domain",
    hardwareId: "Hardware-ID",
    hardwareName: "Hardware-Name",
    hardwareSerialNumber: "Hardware-Seriennummer",
    hardwareModel: "Hardware-Modell",
    hardwareVendor: "Hardware-Produktlinie",
    hardwareType: "Hardware-Typ",
    sfdcId: "SFDC-ID",
    iseoSelloutOrderId: "ISEO-Verkaufsauftrag-ID",
    iseoSelloutOrderDate: "ISEO-Verkaufsauftragsdatum",
    iseoSelloutInvoiceId: "ISEO-Verkaufsrechnungs-ID",
    iseoSelloutInvoiceDate: "ISEO-Verkaufsrechnungsdatum",
    sofiaCustRef: "Kunden-Referenz (Sofia-Prozess)",
    unreconciledHardware: "Nicht abgeglichene Hardware",
    hardwareWithSalesInfo: "Hardware mit Verkaufsinformationen",
    actions: "Aktionen",
    addSalesInfo: "Verkaufsinformationen hinzufügen",
    editSalesInfo: "Verkaufsinformationen bearbeiten",
    iseoSelloutOrder: "ISEO-Verkaufsauftrag",
    iseoSelloutInvoice: "ISEO-Verkaufsrechnung",
    selectedSalesInfoError: "Warnung! Die Auswahl ist nicht homogen. Möchten Sie fortfahren?"
  },
  errors: {
    errorPreviewingFile: 'Fehler beim Vorschauen der Datei. Bitte überprüfen Sie das Dateiformat oder laden Sie eine andere Datei hoch',
    fileFormatNotSupported: 'Dateiformat nicht unterstützt',
    deleteWalletSubscriptionError: "Beim Ändern des Abonnements ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie unseren Support",
    modifyVarOpportunityError: "Beim Bearbeiten des Angebots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    error: "Fehler",
    loginFailed: "Die Sitzung ist abgelaufen. Bitte melden Sie sich erneut an",
    loginGoogleFailedTitle: "Google-Anmeldung fehlgeschlagen",
    loginGoogleFailed: "Stellen Sie sicher, dass Sie in Ihrem Google-Konto angemeldet sind oder versuchen Sie, diese Seite in einer Google Chrome-Sitzung mit Ihrem Sofia GSuite-Konto zu öffnen",
    loginJagoGoogleFailedTitle: "Jago Google-Anmeldung fehlgeschlagen",
    loginJagoGoogleFailed: "Stellen Sie sicher, dass Sie einen Benutzer in Jago haben, der Ihrem Sofia GSuite-Konto entspricht, und versuchen Sie es erneut",
    getDomainDetailsError: "Beim Abrufen der Domain-Konfiguration ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Sofia-Support",
    updateDomainConfigError: "Beim Speichern der Standort-Konfiguration ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Sofia-Support",
    updatePlantThemeError: "Beim Speichern des Standort-Themas ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Sofia-Support",
    impersonateDomainUserError: "Beim Imitieren des Benutzers ist ein Fehler aufgetreten. Bitte überprüfen Sie, ob der Benutzer aktiv ist, und versuchen Sie es erneut oder kontaktieren Sie den Sofia-Support",
    createDomainError: "Beim Erstellen der neuen Domain ist ein Fehler aufgetreten",
    addDomainPluginError: "Beim Erweitern der Domain ist ein Fehler aufgetreten",
    addUserDomainError: "Benutzer konnte nicht erstellt werden. Überprüfen Sie, ob der Benutzer bereits in der Domain existiert oder ob die Domain ein gültiges Abonnement hat",
    deleteDomainUserError: "Benutzer konnte nicht gelöscht werden. Bitte versuchen Sie es erneut",
    errorSaveAdditionalInfo: "Die Informationen in der ausgewählten Domain konnten nicht aktualisiert werden",
    createCustomerError: "Der Endnutzer konnte nicht erstellt werden. Überprüfen Sie, ob der Endnutzer bereits existiert, und versuchen Sie es erneut",
    createUserError: "Der Benutzer konnte nicht erstellt werden. Überprüfen Sie, ob der Benutzer bereits existiert, und versuchen Sie es erneut",
    createVarUserError: "Der VAR-Benutzer konnte nicht erstellt werden. Überprüfen Sie, ob der Benutzer bereits existiert, und versuchen Sie es erneut",
    createPlantThemeError: "Das Standort-Thema konnte nicht erstellt werden. Überprüfen Sie die Daten und versuchen Sie es erneut",
    updateVarError: "Die Aktualisierung ist fehlgeschlagen. Überprüfen Sie die Daten und versuchen Sie es erneut",
    createCustomerContractError: 'Der Service-Vertrag konnte nicht erstellt werden. Überprüfen Sie die Daten und versuchen Sie es erneut',
    getCustomerContractDetailsError: 'Der Service-Vertrag konnte nicht abgerufen werden. Bitte versuchen Sie es erneut',
    getCustomerDetailsError: "Die Endnutzer-Details konnten nicht abgerufen werden. Bitte versuchen Sie es erneut",
    getVarDetailsError: "Die VAR-Details konnten nicht abgerufen werden. Bitte versuchen Sie es erneut",
    getPlantThemeDetailsError: "Die Details des Standort-Themas konnten nicht abgerufen werden. Bitte versuchen Sie es erneut",
    getProductInfoPostDetailsError: "Der Artikel konnte nicht abgerufen werden. Bitte versuchen Sie es erneut",
    required: "Erforderlich",
    deleteDomainRequestError: "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut",
    deleteWalletRequestError: "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut",
    deleteCustomerRequestError: "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut",
    enableIrisDomainRequestError: "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut",
    updatePlantDetailsError: "Anlagendetails konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut",
    createCustomerWalletError: "Das neue Wallet konnte nicht erstellt werden. Bitte versuchen Sie es erneut",
    editCustomerWalletError: "Das Wallet konnte nicht bearbeitet werden. Bitte versuchen Sie es erneut",
    getWalletDetailsError: "Die Wallet-Details konnten nicht abgerufen werden. Bitte versuchen Sie es erneut",
    openSystemParametersError: "Die Systemparameter konnten nicht geöffnet werden. Bitte versuchen Sie es erneut",
    createSubscriptionError: "Das Abonnement konnte nicht erstellt werden. Bitte versuchen Sie es erneut",
    createCardError: "Beim Erstellen der Aufladekarte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    createVarOpportunityError: "Beim Erstellen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    editVarOpportunityError: "Beim Vorgang ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    rechargeWalletError: "Beim Aufladen des Wallets ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    deleteCardError: "Beim Löschen der Aufladekarte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    enableCardError: "Beim Aktualisieren der Aufladekarte ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    deletePlantThemeError: "Beim Löschen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    deleteVarUserError: "Beim Löschen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    deleteVarUserErrorOpportunities: "Dieser Benutzer ist Eigentümer mindestens eines Angebots, daher kann er nicht gelöscht werden. Bitte weisen Sie die diesem Benutzer zugeordneten Angebote neu zu und versuchen Sie es erneut.",
    deleteVarOpportunityError: "Beim Löschen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    rejectVarOpportunityError: "Beim Aktualisieren des Angebots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    approveVarOpportunityError: "Beim Aktualisieren des Angebots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    syncsfdcidVarOpportunityError: "Beim Aktualisieren des Angebots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    upgradeVarOpportunityError: "Beim Aktualisieren des Angebots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    winVarOpportunityError: "Beim Aktualisieren des Angebots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    loseVarOpportunityError: "Beim Aktualisieren des Angebots ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    deleteUserError: "Beim Löschen ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    createWalletSubscriptionError: "Beim Zuweisen des Abonnements zum Wallet ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    createWalletPlantError: "Beim Erstellen der Domain für das Wallet ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    walletActionErrorNotEnoughCreditsTitle: "Nicht genügend Guthaben",
    walletActionErrorNotEnoughCredits: "Das Wallet hat nicht genügend Guthaben, um den Vorgang durchzuführen. Überprüfen Sie den Vorgang und versuchen Sie es erneut",
    warningMinCreditsCard: "Warnung! Mindestanzahl erforderlicher Credits = {{credits}}",
    loginJagoOTPEmailFailedTitle: "E-Mail-Versandfehler",
    loginJagoOTPEmailFailed: "Beim Versenden der E-Mail ist ein Fehler aufgetreten, versuchen Sie es in 5 Minuten erneut",
    loginJagoOTPFailedTitle: "Code-Verifizierungsfehler",
    loginJagoOTPFailed: "Die Verifizierung des Zugangscodes war nicht erfolgreich. Bitte überprüfen Sie den Code oder versuchen Sie es in 5 Minuten erneut.",
    addonV364missing: "Das V364-Add-on konnte im System nicht gefunden werden, bitte melden Sie diesen Fehler, um Unterstützung zu erhalten.",
    openIseoTrainingMaterialsError: "Beim Laden der ISEO-Schulungsmaterialien ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut"
  },
  gateways: {
    deployments: 'Deployments',
    showDeployments: 'Deployments anzeigen',
    showLogs: 'Show Logs',
    gatewayLogsTitle: 'Gateway logs',
    gatewayLogsTimestamp: 'Time',
    gatewayLogsLevel: 'Level',
    gatewayLogsLevelFilter: 'Log-Level',
    gatewayLogsLevelFilterAll: 'Alle',
    gatewayLogsLevelError: '4 (Fehler)',
    gatewayLogsLevelInfo: '6 (Info)',
    gatewayLogsSummary: 'Summary',
    gatewayLogsContext: 'Context',
    gatewayLogsFullLine: 'Full line',
    gatewayLogsMessage: 'Message',
    gatewayLogsEmpty: 'No log lines found for this device in the selected time range.',
    gatewayLogsRefresh: 'Refresh',
    gatewayLogsDeviceIdLabel: 'Device',
    gatewayLogsFilterContext: 'Filter context',
    gatewayLogsFilterContextPlaceholder: 'Contains…',
    gatewayLogsFilterText: 'Search in log',
    gatewayLogsFilterTextPlaceholder: 'Filter in full line, summary…',
    gatewayLogsDateFrom: 'From',
    gatewayLogsDateTo: 'To',
    gatewayLogsApplyRange: 'Apply range',
    gatewayLogsRangeHint: 'Max span between From and To dates: 8 calendar days',
    gatewayLogsNoFilterMatch: 'No rows match the current filter.',
    gatewayLogsErrorGeneric: 'Could not load gateway logs from the server. Please try again.',
    getGatewayDeploymentsError: 'Beim Abrufen der Deployments ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut',
    createdBy: 'Erstellt von',
    noGatewayFoundTitle: 'Kein HyperGate gefunden',
    noGatewayFoundDescription: 'Die Liste der HyperGate ist leer. Wenn Sie einen Suchfilter festgelegt haben, versuchen Sie, ihn zu ändern und erneut zu suchen',
    gatewayName: 'HyperGate-Name',
    luckeyGatewaysTitle: 'System HyperGates',
    lastConnectionDate: 'Letzte Verbindung: {{ date }}',
    gatewaysDevices: 'Geräte',
    gatewaysArtifacts: 'Artifacts',
    gatewaysDeployments: 'Deployments',
    noArtifactFoundTitle: 'Kein Artifact gefunden',
    noArtifactFoundDescription: 'Die Liste der Artifacts ist leer. Wenn Sie einen Suchfilter festgelegt haben, versuchen Sie, ihn zu ändern und erneut zu suchen',
    noDeploymentFoundTitle: 'Kein Deployment gefunden',
    noDeploymentFoundDescription: 'Die Liste der Deployments ist leer. Wenn Sie einen Suchfilter festgelegt haben, versuchen Sie, ihn zu ändern und erneut zu suchen',
    newDeployment: 'Neues Deployment',
    deploymentScheduledAt: 'Deployment geplant am',
    gatewaysArtifact: 'Artifact',
    gateways: 'Gateways',
    artifactName: 'Artifact-Name',
    createNewDeployment: 'Neues Deployment erstellen',
    selectHyperGates: 'HyperGates auswählen',
    allGateways: 'Auf allen HyperGates bereitstellen',
    HYPERGATE_PRO: 'HyperGate Pro',
    HYPERGATE_ISEO: 'HyperGate Lite',
    deploymentDetail: 'Deployment-Details',
    noDeploymentDetailedFound: 'Kein Gateway für das Deployment gefunden',
    noDeploymentDetailedFoundDescription: 'Die Liste der Gateways für dieses Deployment ist leer',
    DONE: 'Abgeschlossen',
    PENDING: 'Freigabe in Arbeit',
    IN_PROGRESS: 'Installation',
    ERROR: 'Fehler',
    deviceId: 'Geräte-ID',
    name: 'Name',
    gatewayVersion: 'Version',
    iseoSdkVersion: 'ISEO SDK',
    kernelVersion: 'Kernel Version',
    serialNumber: 'Seriennummer',
    noGatewaysFound: 'Kein Gateway gefunden',
    noGatewaysFoundDescription: 'Die Liste der Gateways ist leer. Versuchen Sie, den Suchfilter zu ändern und erneut zu suchen',
    noDeploymentFound: 'Kein Deployment gefunden',
    noArtifactFound: 'Kein Artifact gefunden',
  },
  forms: {
    createResource: 'Ressource erstellen',
    subscriptionCategory: 'Kategorie',
    createNew: 'Neu',
    aggregateByMonth: 'Monatliche Zusammenfassung',
    findOutMore: 'Mehr erfahren',
    findOutMoreAboutThisFeature: 'Mehr erfahren über diese Funktion',
    extraCredentials: 'Extra Credenzialen',
    invitations: 'Aktive Einladungen',
    anonymizeAllEvents: 'Lösche Benutzerdaten aus Smart Lock Events und Management Events',
    deleteAllStandardDevices: 'Lösche alle RFID Cards, PIN codes und F9000 keys assigned to this user',
    numberOfDomains: 'Domänen',
    walletDetails: 'Wallet-Details',
    subscriptionDetails: 'Abonnement-Details',
    smartLocks: 'Schlösser',
    users: 'Benutzer',
    numberOfElements: 'Elemente',
    segment: 'Segment',
    otpLoginOnly: 'OTP-Login nur für dieses System aktivieren',
    synchronizationCompleted: 'Synchronisation erfolgreich abgeschlossen',
    sfdcSync: 'SFDC-Synchronisierung',
    customerAdditionalData: 'Zusätzliche Informationen',
    customerVatVerificationTitle: 'Kundendaten aus ISEO-Systemen abrufen',
    verify: 'Überprüfen',
    otp: 'OTP',
    notVisible: "Nicht sichtbar",
    visible: "Sichtbar",
    exportAllUsers: "Benutzer exportieren",
    montlyBurnRate: "{{credits}}/Monat",
    nextRechargeForecast: "Nächste Aufladung erwartet mit aktuellem Verbrauch ~{{date}}",
    creditsFinishedInDate: "Credits sind am {{date}} aufgebraucht",
    lastUpdate: "Letzte Aktualisierung {{time}}",
    rowsPerPage: "Zeilen pro Seite",
    rolePermissions: "Rollenberechtigungen",
    permissionsDetails: "Berechtigungsdetails",
    clusterAndIseoCompany: "Cluster und ISEO-Unternehmen",
    createCardSuccess: "Aufladekarte erfolgreich erstellt",
    cardDetails: "Kartendetails",
    status: "Status",
    customerInfo: "Kundeninformationen",
    details: "Details",
    costs: "Kosten",
    hostName: "Hostname",
    domainType: "Typ",
    user: "Benutzer",
    logoutConfirmation: "Sind Sie sicher, dass Sie sich abmelden möchten?",
    send: "Senden",
    askQuestion: "Kontaktieren Sie uns",
    ticketOpenSuccessfully: "Ihre Anfrage wurde an unser Team gesendet! Ein Teammitglied wird sich in Kürze mit Ihnen in Verbindung setzen.",
    ticketOpenError: "Beim Senden der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    writeUsAQuestionDescription: "Haben Sie eine Frage? Schreiben Sie uns gerne, und einer unserer Produktspezialisten wird Ihnen bei allen Anfragen zur Seite stehen.",
    deviceType: "Gerätetyp",
    createNewMarketplace: "Neuen Marktplatz erstellen",
    createNewCustomer: "Neu",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    contactEmail: "Kontakt-E-Mail",
    marketplace: "Marktplatz",
    open: "Öffnen",
    add: "Hinzufügen",
    actions: "Aktionen",
    search: "Suchen",
    remove: "Entfernen",
    error: "Fehler",
    copy: "Kopieren",
    cancel: "Abbrechen",
    confirm: "Bestätigen",
    warning: "Warnung",
    reset: "Zurücksetzen",
    close: "Schließen",
    save: "Speichern",
    delete: "Löschen",
    duplicate: "Duplizieren",
    deleteRequest: "Löschanfrage senden",
    deleteAdminOnly: "Löschen (Admin)",
    export: "Exportieren",
    spinnerLoading: "Laden...",
    createNewDomain: "Neue Domain erstellen",
    walletName: "Wallet-Name",
    domainName: "Domain-Name",
    domainNamePreview: "Vorschau",
    domainFormTitle: "Neue Luckey-Domain erstellen",
    invalidDomainName: "Ungültiger Domain-Teil. Max. 50 Zeichen: Buchstaben und Ziffern, Bindestrich nur in der Mitte (nicht am Anfang oder Ende), keine Leerzeichen",
    selectProduct: "Abonnement-Typ auswählen",
    name: "Vorname",
    lastname: "Nachname",
    createNewUser: "Neuen Manager erstellen",
    selectRole: "Benutzerrolle auswählen",
    createUserForDomain: "Neuen Benutzer für die ausgewählte Domain erstellen",
    newUser: "Neuer Benutzer",
    password: "Passwort",
    letUserChoosePassword: "Benutzer das Passwort wählen lassen: Passwort-Einstell-Link an die Benutzer-E-Mail senden",
    domainCreateSuccess: "Domain erfolgreich erstellt",
    domainCreateUserAfterCreation: "Möchten Sie einen Benutzer für die neue Domain erstellen?",
    domainCreationConfirm: "Möchten Sie die neue Domain erstellen?",
    createDomain: "Domain erstellen",
    username: "Benutzername",
    domainExtendsConfirm: "Möchten Sie die Domain mit dem ausgewählten Produkt erweitern?",
    createNewInstaller: "Neuen Installer erstellen",
    createInstallerForDomain: "Neuen Installer-Benutzer für die Domain erstellen",
    deleteDomain: "Domain-Löschung anfordern",
    active: "Aktiv",
    disabled: "Deaktiviert",
    minutes: "{{minutes}} Minuten",
    selectSessionDurationPlaceholder: "Sitzungsdauer",
    impersonateUserDescription: "Bevor Sie den Benutzer im System imitieren, informieren wir Sie, dass:",
    impersonateUserDescriptionOne: "Der Beginn der Sitzung und deren Dauer in den Domain-Protokollen erscheinen werden",
    impersonateUserDescriptionTwo: "Jede Aktion, die Sie durchführen, wird protokolliert und erscheint in den Systemprotokollen",
    impersonateUserDescriptionThree: "Jede Aktion, die Sie am Implantat durchführen, hat sofortige und in manchen Fällen irreversible Auswirkungen",
    selectSessionDuration: "Sitzungsdauer der Support-Sitzung auswählen",
    impersonateReadOnly: "Nur-Lesen-Modus imitieren",
    impersonateReadOnlyDescription: "Greifen Sie im Nur-Lesen-Modus auf das System zu, Sie können die Systemdaten sehen, aber nicht ändern",
    impersonateReadOnlyWarning: "Achtung: Die Support-Sitzung und deren Dauer bleiben in den Systemprotokollen sichtbar",
    installationModeActive: "Aktiv",
    installationModeDisabled: "Deaktiviert",
    customerFormTitle: "Luckey-Endnutzer",
    varFormTitle: "Value Added Reseller (VAR)",
    varFormAdminSection: "Admin-Bereich",
    varFormTitleVar: "Firmeninformationen",
    plantThemeFormTitle: "Luckey-Plant-Thema",
    customerName: "Endnutzername",
    invalidCustomerName: "Ungültiger Endnutzername",
    createNewWallet: "Neues Wallet",
    whatsNewTitle: "Luckey Neuigkeiten!",
    whatsNewSubtitle: "Entdecken Sie die neuesten Nachrichten über Luckey und Sofia, Teil von ISEO",
    notes: "Zusätzliche Notizen",
    cardCode: "Aufladecode",
    recharge: "Aufladen",
    rechargeWalletFormDescription: "Laden Sie die Credits dieses Wallets auf, indem Sie den Aufladecode eingeben. Die Aufladung wird sofort wirksam",
    subscriptionName: "Abonnement-Name",
    subscriptionFixedPrice: "Aktivierungskosten (Credits)",
    subscriptionBurnRate: "Wiederkehrende Kosten (Credits)",
    subscriptionVisible: "Auf dem Marktplatz sichtbar",
    createNewSubscriptionDescription: "Erstellen Sie ein neues Abonnement im System. Das Abonnement steht allen Domains zur Verfügung",
    subscriptionLogicDescription: "Gibt an, welche Elemente des Systems gezählt werden, um die Systembeschränkungen zu bestimmen",
    FIXED: "Keine Beschränkungen für Elemente",
    COUNT_USERS_LOCKS: "Begrenzung der Anzahl von Benutzern und Domain-Schlössern",
    COUNT_LOCKS: "Nur Begrenzung der Anzahl von Domain-Schlössern",
    COUNT_ELEMENTS: "Begrenzung der Summe von Schlössern und Domain-Benutzern",
    maxLocks: "Maximale Anzahl an Smart Locks",
    maxUsers: "Maximale Anzahl an Benutzern",
    maxElements: "Maximale Anzahl an Elementen (Benutzer + Schlösser)",
    subscriptionLogic: "Elementbegrenzungslogik",
    selectLogic: "Auswählen",
    subscriptionMaxLocksDescription: "Geben Sie die maximale Anzahl an Schlössern ein, die mit diesem Abonnement installiert werden können",
    subscriptionMaxUsersDescription: "Geben Sie die maximale Anzahl an Benutzern ein, die mit diesem Abonnement aktiviert werden können",
    subscriptionMaxElementsDescription: "Geben Sie die maximale Anzahl an Elementen mit diesem Abonnement ein",
    subscriptionResource: "Ressource",
    cardQuantity: "Anzahl der Credits",
    cardQuantityDescription: "Gibt an, wie viele Credits bei Verwendung der Aufladekarte aufgeladen werden",
    cardVar: "Aufladekarte dem VAR zuweisen",
    cardWallet: "Aufladekarte einem bestimmten Wallet zuweisen",
    cardNotes: "Zusätzliche Notizen",
    createCardConfirm: "Sind Sie sicher, dass Sie die Aufladekarte erstellen möchten?",
    createVarOpportunityConfirm: "Sind Sie sicher, dass Sie dieses neue Angebot erstellen möchten?",
    createSubscrptionConfirm: "Sind Sie sicher, dass Sie das neue Abonnement erstellen möchten?",
    rechargeWalletConfirm: "Sie sind dabei, das Wallet dieses Endnutzers mit neuen Credits aufzuladen, möchten Sie fortfahren? Dieser Vorgang kann nicht rückgängig gemacht werden",
    createdAt: "Erstellungsdatum",
    copiedSuccess: "Kopiert!",
    logout: "Abmelden",
    deleteCardConfirm: "Sind Sie sicher, dass Sie diese Aufladekarte löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    enableCardConfirm: "Sind Sie sicher, dass Sie diese Aufladekarte aktivieren möchten? Sobald sie aktiviert ist, kann diese Karte verwendet werden. Dieser Vorgang kann nicht rückgängig gemacht werden",
    subscriptionTierSelectionTitle: "Hauptabonnement",
    subscriptionTierSelectionDescription: "Durch die Auswahl des Hauptabonnements erbt das neue Add-on automatisch die Zähllogiken des Hauptabonnements",
    selectTier: "Abonnement auswählen",
    createPluginSubscriptionConfirm: "Sind Sie sicher, dass Sie dieses neue Add-on/Service-Abonnement erstellen möchten?",
    createWalletSubscriptionConfirm: "Sind Sie sicher, dass Sie dieses Abonnement dem ausgewählten Wallet zuweisen möchten? Das Abonnement wird für alle über dieses Wallet verwalteten Standorte aktiviert",
    deleteWalletSubscriptionConfirm: "Sind Sie sicher, dass Sie dieses Abonnement aus dem ausgewählten Wallet entfernen möchten? Das Abonnement wird von allen über dieses Wallet verwalteten Standorten entfernt",
    editSubscriptionConfirm: "Sind Sie sicher, dass Sie das Abonnement bearbeiten möchten?",
    walletSelectSubscriptionTitle: "Zu aktivierendes Abonnement",
    walletSelectSubscriptionDescription: "Wählen Sie das Abonnement aus, das in diesem Wallet aktiviert werden soll. Denken Sie daran, dass das Abonnement auch in allen über dieses Wallet verwalteten Systemen aktiviert wird",
    createWalletPlantConfirm: "Sind Sie sicher, dass Sie die neue Domain für das ausgewählte Wallet erstellen möchten?",
    enableEmailForPlant: "E-Mail-Dienst aktivieren",
    enableEmailForPlantDescription: "Aktivieren Sie den Versand von E-Mails für dieses System (Aktivierungs-E-Mail, Benachrichtigungen etc.)",
    enableIrisRequiredForPlant: "1RIS-Dienst erforderlich",
    enableIrisRequiredForPlantDescription: "Wenn ausgewählt, wird die Domain darauf vorbereitet, den 1RIS-Dienst zu integrieren",
    cardSubscriptionsLinked: "Verknüpfte Abonnements",
    cardSubscriptionsLinkedDescription: "Verknüpfen Sie mehrere Add-ons oder Services mit dieser Aufladekarte, um sie zu aktivieren, sobald die Karte verwendet wird",
    mainTierDescription: "Verknüpfen Sie ein Hauptabonnement mit dieser Aufladekarte, um es zu aktivieren, sobald die Karte verwendet wird",
    cardMarketplacesLinked: "Marktplatz zur Lizenzzuweisung",
    cardMarketplacesLinkedDescription: "Wählen Sie einen Marktplatz aus, um die Abonnements auszuwählen, die mit dieser Aufladekarte verknüpft werden sollen",
    sku: "SKU",
    customerData: "Kundendaten",
    customerVat: "USt.",
    customerFiscalCode: "Steuercode",
    customerCountry: "Land",
    customerAddress: "Adresse",
    customerCity: "Stadt",
    customerEmail: "E-Mail",
    customerPhone: "Telefon",
    customerCrmId: "SFDC ACCOUNT ID",
    customerMarketplace: "Marktplatz",
    customerCertifiedEmail: "PEC (Zertifizierte E-Mail)",
    customerKamEmail: "Key Account Manager",
    customerCluster: "Cluster",
    customerVar: "VAR",
    customerCompany: "ISEO-Unternehmen",
    customerPostalCode: "Postleitzahl",
    customerPrincipalSubDivision: "Bezirk, Bundesland, Kreis, etc.",
    iseoSalesOrderReference: "ISEO Verkaufsauftrag (ISEO -> Kunde)",
    iseoSalesOrderDate: "ISEO Verkaufsauftragsdatum",
    iseoPurchaseOrderReference: "ISEO Einkaufsauftrag (ISEO -> Sofia)",
    iseoPurchaseOrderDate: "ISEO Einkaufsauftragsdatum",
    sofiaSalesOrderReference: "Sofia Verkaufsauftrag (Sofia -> ISEO)",
    sofiaSalesOrderDate: "Sofia Verkaufsauftragsdatum",
    pickDate: "Datum auswählen",
    crmSource: "CRM Opportunity Quelle",
    crmId: "Eindeutiger CRM Opportunity Identifier",
    sofiaProjectId: "Sofia Projekt Referenz-Identifier",
    crmLink: "URL zur CRM Opportunity",
    kamReference: "KAM-Referenz",
    edit: "Bearbeiten",
    editCardConfirm: "Sind Sie sicher, dass Sie die Aufladekarte bearbeiten möchten?",
    editVarOpportunityConfirm: "Sind Sie sicher, dass Sie dieses Angebot bearbeiten möchten?",
    insertEmailOTPLoginForm: "Geben Sie Ihre Konto-E-Mail ein, um den OTP-Code zu erhalten und auf die Plattform zuzugreifen",
    insertEmailOTPLoginFormDisclaimer: "Wenn die E-Mail autorisiert ist, erhalten Sie einen OTP-Code zum Zugriff",
    insertOTPOTPLoginForm: "Geben Sie den an Ihre Konto-E-Mail gesendeten OTP-Code ein",
    insertOTPOTPLoginFormDisclaimer: "Falls Sie den Code nach 5 Minuten nicht erhalten, wiederholen Sie den Vorgang",
    pickDateTo: "Datum auswählen bis:",
    pickDateFrom: "Datum auswählen von",
    AUTOMATIC: "Automatische Aktivierung",
    MANUAL: "Manuelle Aktivierung",
    SEMI_AUTOMATIC: "Halbautomatische Aktivierung",
    AUTOMATIC_Description: "Die Erweiterung kann unabhängig vom Shop vom Benutzer aktiviert werden. Die Aktivierungscredits werden sofort abgezogen",
    MANUAL_Description: "Erweiterung, die nur nach einer ausdrücklichen Anfrage des Endnutzers aktiviert werden kann. Die Credits werden manuell nach Genehmigung der Anfrage abgezogen",
    SEMI_AUTOMATIC_Description: "Erweiterung, die nur nach einer ausdrücklichen Anfrage des Endnutzers aktiviert werden kann. Die Aktivierungscredits werden im Moment der Anfrage abgezogen",
    requestToQuote: "Angebot angefordert",
    requestToQuoteDescription: "Geben Sie an, ob die Erweiterung einem Angebot unterliegt, anstatt Credits direkt zu verwenden (z.B. bei Integrationen und Anpassungen)",
    subscriptionCanBeDeactivated: "Kann vom Manager deaktiviert werden",
    subscriptionCanBeDeactivatedDescription: "Geben Sie an, ob der Manager das Abonnement im Luckey Store deaktivieren kann",
    selectSegmentType: "Segment auswählen",
    sofiaInvoiceNumber: "Sofia Rechnungsnummer",
    sofiaInvoiceAmount: "Sofia Rechnungsbetrag",
    sofiaInvoiceYear: "Sofia Rechnungsjahr",
    iseoInvoiceNumber: "ISEO Rechnungsnummer",
    iseoInvoiceAmount: "ISEO Rechnungsbetrag",
    iseoInvoiceYear: "ISEO Rechnungsjahr",
    freeOfCharge: "Kostenlos",
    freeOfChargeReason: "Grund",
    currency: "Währung",
    sofiaInvoiceDate: "Rechnungsdatum",
    iseoInvoiceDate: "Rechnungsdatum",
    sofiaInvoiceRecipient: "Rechnungsempfänger",
    iseoInvoiceRecipient: "Rechnungsempfänger",
    serviceSupplementaryInvoice: "Service-Nachrechnung",
    serviceSupplementaryInvoiceNumber: "Rechnungsnummer",
    serviceSupplementaryInvoiceAmount: "Rechnungsbetrag",
    serviceSupplementaryInvoiceDate: "Rechnungsdatum",
    serviceSupplementaryInvoiceRecipient: "Rechnungsempfänger",
    iseoInvoiceIssuer: "Rechnungsaussteller",
    backdropClosing: "Sind Sie sicher, dass Sie das Formular ohne Speichern schließen möchten?",
    roles: "Rollen",
    selectBotType: 'Assistenten Typ auswählen',
    helperBot: 'Produktassistent',
    commercialBot: 'Handelsassistent',
    talkWithUs: 'Talk mit uns',
    noBotTypeSelected: 'Kein Assistenttyp ausgewählt',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    customer: 'End-user standard',
    simplifiedCustomer: 'End-user vereinfacht',
  },
  activations: {
    cluster: 'Cluster',
    clusters: 'Clusters',
    getInfo: "(Mehr Informationen zum Prozess erhalten)",
    createNewCustomer: "Endnutzer erstellen",
    createNewWallet: "Wallet erstellen",
    createNewScratchcard: "Aufladekarte erstellen",
    yearsString: "Jahre",
    monthsString: "Monate",
    daysString: "Tage",
    addNewActivationButton: "Systemaktivierung hinzufügen",
    home: "OD-Startseite",
    activationRequests: "Systemaktivierungen",
    rechargeRequests: "Wallet-Aufladungen",
    walletStatus: "Auftragsstatus",
    noActivationsFoundTitle: "Keine Systemaktivierungen gefunden",
    noActivationsFoundDescription: "Es sind keine Systemaktivierungen im System vorhanden. Erstellen Sie neue, um zu beginnen",
    selloutOrder: "Sell-out-Auftrag",
    intragroupOrder: "Intragruppen-Auftrag",
    custref: "Kunden-Referenz",
    rejectedReason: "Ablehnungsgrund",
    changeStatusToUnderReview: "Zur Prüfung senden",
    changeStatusToInvoiced: "Auf Rechnung setzen",
    changeStatusToCreated: "Als erstellt markieren",
    changeStatusToRejected: "Anfrage ablehnen",
    changeStatusToProcessing: "Anfrage akzeptieren",
    changeStatusAdmin: "Status festlegen (Admin)",
    changeCustRef: "Kunden-Referenz festlegen",
    search: "Suchen...",
    resetFilters: "Filter zurücksetzen",
    statusSelection: "Jeder Status",
    clusterSelection: "Jeder Cluster",
    statusDRAFT: "Entwurf",
    statusUNDER_REVIEW: "In Prüfung",
    statusREJECTED: "Abgelehnt",
    statusPROCESSING: "In Bearbeitung",
    statusCREATED: "Erstellt",
    statusINVOICED: "Rechnungs gestellt",
    statusACTIVE: "Aktiv",
    statusDELETED: "Gelöscht",
    promote: "Löschen",
    saveDraft: "Als Entwurf speichern",
    customMarketplaceWarning: "Der Endnutzer ist nicht dem Standard-Marktplatz zugeordnet. Sie müssen das angeforderte Basisabonnement und die Add-ons manuell im Bereich 'Notizen' angeben",
    subscriptionNotFoundError: "Abonnement nicht gefunden",
    deleteActivationConfirm: "Sind Sie sicher, dass Sie diese Systemaktivierung löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    deleteActivationError: "Beim Löschen der Systemaktivierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    promoteActivationConfirm: "Sind Sie sicher, dass Sie diese Systemaktivierung zur Prüfung senden möchten? Die Anfrage kann in der Prüfung nicht bearbeitet werden.",
    promoteActivationError: "Beim Senden der Systemaktivierung zur Prüfung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    createdActivationConfirm: "Sind Sie sicher, dass Sie diese Systemaktivierung auf den Status ERSTELLT setzen möchten?",
    createdActivationError: "Beim Aktualisieren des Status der Systemaktivierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    invoicedActivationConfirm: "Sind Sie sicher, dass Sie diese Systemaktivierung als Rechnungs gestellt markieren möchten?",
    invoicedActivationError: "Beim Aktualisieren des Status der Systemaktivierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    editStatusActivationConfirm: "Sind Sie sicher, dass Sie den Status dieser Systemaktivierung bearbeiten möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    editStatusActivationError: "Beim Aktualisieren des Status der Systemaktivierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    rejectActivationConfirm: "Geben Sie den Ablehnungsgrund für diese Anfrage an.",
    rejectActivationError: "Beim Ablehnen der Systemaktivierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    processingActivationConfirm: "Sind Sie sicher, dass Sie diese Systemaktivierung akzeptieren möchten?",
    processingActivationError: "Beim Akzeptieren der Systemaktivierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    newFileName: "Geben Sie den Dateinamen an",
    newFileExtensionError: "Die Datei hat eine nicht unterstützte Erweiterung",
    newFileDuplicateNameError: "Dieser Name wurde bereits für eine andere Datei verwendet. Ändern Sie den Namen und versuchen Sie es erneut.",
    editCustrefConfirm: "Geben Sie die Kunden-Referenz für diese Anfrage an.",
    editCustrefError: "Beim Aktualisieren der Kunden-Referenz ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
    editActivation: "Systemaktivierung bearbeiten",
    newActivation: "Systemaktivierung hinzufügen",
    viewActivation: "Systemaktivierung anzeigen",
    newActivationError: "Beim Erstellen dieser Systemaktivierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    editActivationError: "Beim Aktualisieren dieser Systemaktivierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    customerSearch: "Unter den vorhandenen Endnutzern suchen",
    customerSearchEnterName: "Nach Name suchen...",
    customerSearchNoMatch: "Keine Endnutzer gefunden...",
    customerProceedWithSelected: "Ausgewählten Endnutzer verwenden",
    customerProceedWithNew: "Neuen Endnutzer erstellen",
    customerConfirmData: "Daten des Endnutzers bestätigen",
    customerData: "Kundendaten",
    varData: "VAR-Daten",
    selectCustomerOrVar: "Wählen Sie das Ziel für diese Anfrage (Endnutzer oder VAR)",
    varSfdcId: "SFDC ACCOUNT ID",
    varName: "Name",
    varSearch: "Unter den vorhandenen VARs suchen",
    varSearchEnterName: "Nach Name suchen...",
    varSearchNoMatch: "Kein VAR gefunden...",
    varCustomerSearch: "Unter den Endnutzern des VAR suchen",
    varProceedWithSelected: "Ausgewählten VAR verwenden",
    customerFormTitle: "Luckey Endnutzer",
    customerContractFormTitle: "Servicevertrag",
    customerName: "Name des Endnutzers",
    customerVat: "USt.",
    customerFiscalCode: "Steuercode",
    customerCountry: "Land",
    customerAddress: "Adresse",
    customerCity: "Stadt",
    customerEmail: "E-Mail",
    customerPhone: "Telefon",
    customerCrmId: "SFDC ACCOUNT ID",
    customerMarketplace: "Marktplatz",
    customerCertifiedEmail: "PEC (Zertifizierte E-Mail)",
    customerKamEmail: "Key Account Manager",
    customerCluster: "Cluster",
    customerVar: "VAR",
    customerCompany: "ISEO-Unternehmen",
    customerPostalCode: "Postleitzahl",
    customerPrincipalSubDivision: "Bezirk, Bundesland, Kreis, etc.",
    iseoSalesOrderReference: "ISEO Verkaufsauftrag (ISEO -> Kunde)",
    iseoSalesOrderDate: "ISEO Verkaufsauftragsdatum",
    iseoPurchaseOrderReference: "ISEO Einkaufsauftrag (ISEO -> Sofia)",
    iseoPurchaseOrderDate: "ISEO Einkaufsauftragsdatum",
    sofiaSalesOrderReference: "Sofia Verkaufsauftrag (Sofia -> ISEO)",
    sofiaSalesOrderDate: "Sofia Verkaufsauftragsdatum",
    pickDate: "Datum auswählen",
    crmSource: "CRM Opportunity Quelle",
    crmId: "Eindeutiger CRM Opportunity Identifier",
    sofiaProjectId: "Sofia Projekt Referenz-Identifier",
    crmLink: "URL zur CRM Opportunity",
    kamReference: "KAM-Referenz",
    edit: "Bearbeiten",
    editCardConfirm: "Sind Sie sicher, dass Sie die Aufladekarte bearbeiten möchten?",
    editVarOpportunityConfirm: "Sind Sie sicher, dass Sie dieses Angebot bearbeiten möchten?",
    insertEmailOTPLoginForm: "Geben Sie Ihre Konto-E-Mail ein, um den OTP-Code zu erhalten und auf die Plattform zuzugreifen",
    insertEmailOTPLoginFormDisclaimer: "Wenn die E-Mail autorisiert ist, erhalten Sie einen OTP-Code zum Zugriff",
    insertOTPOTPLoginForm: "Geben Sie den an Ihre Konto-E-Mail gesendeten OTP-Code ein",
    insertOTPOTPLoginFormDisclaimer: "Falls Sie den Code nach 5 Minuten nicht erhalten, wiederholen Sie den Vorgang",
    pickDateTo: "Datum auswählen bis:",
    pickDateFrom: "Datum auswählen von",
    AUTOMATIC: "Automatische Aktivierung",
    MANUAL: "Manuelle Aktivierung",
    SEMI_AUTOMATIC: "Halbautomatische Aktivierung",
    AUTOMATIC_Description: "Die Erweiterung kann unabhängig vom Shop vom Benutzer aktiviert werden. Die Aktivierungscredits werden sofort abgezogen",
    MANUAL_Description: "Erweiterung, die nur nach einer ausdrücklichen Anfrage des Endnutzers aktiviert werden kann. Die Credits werden manuell nach Genehmigung der Anfrage abgezogen",
    SEMI_AUTOMATIC_Description: "Erweiterung, die nur nach einer ausdrücklichen Anfrage des Endnutzers aktiviert werden kann. Die Aktivierungscredits werden im Moment der Anfrage abgezogen",
    requestToQuote: "Angebot angefordert",
    requestToQuoteDescription: "Geben Sie an, ob die Erweiterung einem Angebot unterliegt, anstatt Credits direkt zu verwenden (z. B. bei Integrationen und Anpassungen)",
    subscriptionCanBeDeactivated: "Kann vom Manager deaktiviert werden",
    subscriptionCanBeDeactivatedDescription: "Geben Sie an, ob der Manager das Abonnement im Luckey Store deaktivieren kann",
    selectSegmentType: "Segment auswählen",
    sofiaInvoiceNumber: "Sofia Rechnungsnummer",
    sofiaInvoiceAmount: "Sofia Rechnungsbetrag",
    sofiaInvoiceYear: "Sofia Rechnungsjahr",
    iseoInvoiceNumber: "ISEO Rechnungsnummer",
    iseoInvoiceAmount: "ISEO Rechnungsbetrag",
    iseoInvoiceYear: "ISEO Rechnungsjahr",
    freeOfCharge: "Kostenlos",
    freeOfChargeReason: "Grund",
    currency: "Währung",
    sofiaInvoiceDate: "Rechnungsdatum",
    iseoInvoiceDate: "Rechnungsdatum",
    sofiaInvoiceRecipient: "Rechnungsempfänger",
    iseoInvoiceRecipient: "Rechnungsempfänger",
    serviceSupplementaryInvoice: "Service-Nachrechnung",
    serviceSupplementaryInvoiceNumber: "Rechnungsnummer",
    serviceSupplementaryInvoiceAmount: "Rechnungsbetrag",
    serviceSupplementaryInvoiceDate: "Rechnungsdatum",
    serviceSupplementaryInvoiceRecipient: "Rechnungsempfänger",
    iseoInvoiceIssuer: "Rechnungsaussteller",
    backdropClosing: "Sind Sie sicher, dass Sie das Formular ohne Speichern schließen möchten?",
    roles: "Rollen"
  },
  recharges: {
    recalculate: 'Neu berechnen',
    restartRechargeJob: 'Neu berechnen',
    restartRechargeJobConfirm: 'Sind Sie sicher, dass Sie die Berechnung der Wallet-Aufladungen neu starten möchten?',
    restartRechargeJobSuccess: 'Wallet-Aufladungsberechnung erfolgreich neu gestartet',
    restartRechargeJobError: 'Beim Neustarten der Wallet-Aufladungsberechnung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut',
    addNewRechargeButton: "Neue Wallet-Aufladung hinzufügen",
    noRechargesFoundTitle: "Keine Aufladungen gefunden",
    noRechargesFoundDescription: "Es sind keine Wallet-Aufladungen im System vorhanden. Erstellen Sie neue, um zu beginnen",
    customerAndWallet: "Endnutzer und Wallet",
    seeCustomer: "Infos",
    seeCustomerDetails: "Endnutzer-Details anzeigen",
    selloutOrder: "Sell-out-Auftrag",
    intragroupOrder: "Intragruppen-Auftrag",
    custref: "Kunden-Referenz",
    mode: "Vertragsverlängerungstyp:",
    creditsSuggested: "Vorgeschlagene Credits",
    creditsConfirmed: "Bestätigte Credits",
    rejectedReason: "Ablehnungsgrund",
    deletedReason: "Löschgrund",
    createdAt: "Erstellt am",
    updatedAt: "Aktualisiert am",
    customerSearch: "Unter den vorhandenen Endnutzern suchen",
    customerSearchEnterName: "Nach Name suchen...",
    customerSearchNoMatch: "Keine Endnutzer gefunden...",
    varSearch: "Unter den vorhandenen VARs suchen",
    varSearchEnterName: "Nach Name suchen...",
    varSearchNoMatch: "Kein VAR gefunden...",
    varCustomerSearch: "Unter den Endnutzern des VAR suchen",
    plantSearch: "Wählen Sie den gewünschten Standort",
    plantSearchEnterName: "Standort auswählen",
    plantSearchNoMatch: "Kein Standort gefunden...",
    plantProceedWithSelected: "Ausgewählten Standort/Wallet verwenden",
    dataMissingTakenCharge: "Bestätigte Credits und Sell-out angeben, um fortzufahren",
    dataMissingScratchcardCreated: "Rechnungsnummer und PDF angeben, um fortzufahren",
    changeStatusToSelloutOrderGenerated: "Zur Prüfung senden",
    changeStatusToInvoiced: "Als Rechnungs gestellt markieren",
    changeStatusToCreated: "Als erstellt markieren",
    changeStatusToRejected: "Anfrage ablehnen",
    changeStatusToScratchcardCreated: "Aufladung erstellt",
    changeStatusToWalletRecharged: "Wallet aufgeladen",
    changeStatusAdmin: "Status festlegen (Admin)",
    createCard: "Aufladekarte erstellen",
    changeCustRef: "Kunden-Referenz festlegen",
    search: "Suchen...",
    resetFilters: "Filter zurücksetzen",
    statusSelection: "Jeder Status",
    clusterSelection: "Jeder Cluster",
    statusTO_BE_MANAGED: "Zu verwalten",
    statusTAKEN_CHARGE: "In Bearbeitung",
    statusREQUEST_TO_DELETE: "Löschanfrage",
    statusSELLOUT_ORDER_GENERATED: "In Prüfung",
    statusSCRATCHCARD_CREATED: "Aufladung erstellt",
    statusWALLET_RECHARGED: "Aufgeladen",
    statusREJECTED: "Abgelehnt",
    statusDELETED: "Gelöscht",
    statusINVOICED: "Rechnungs gestellt",
    promote: "Löschen",
    saveRequest: "Anfrage speichern",
    createRequest: "Wallet-Aufladung erstellen",
    takeCharge: "Übernehmen",
    AUTO_RENEWABLE: "Automatisch verlängerbar",
    NOT_AUTO_RENEWABLE: "Nicht automatisch verlängerbar",
    deleteRechargeConfirm: "Sind Sie sicher, dass Sie diese Anfrage löschen möchten? Bitte geben Sie den Grund an. Dieser Vorgang kann nicht rückgängig gemacht werden",
    deleteAdminRechargeConfirm: "Sind Sie sicher, dass Sie diese Anfrage dauerhaft löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    deleteRechargeError: "Beim Löschen der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    takechargeRechargeConfirm: "Bitte geben Sie den Verlängerungstyp an, um mit dieser Anfrage fortzufahren",
    takechargeRechargeDirectConfirm: "Sind Sie sicher, dass Sie diese Anfrage übernehmen möchten?",
    takechargeRechargeError: "Beim Übernehmen der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    promoteRechargeConfirm: "Sind Sie sicher, dass Sie diese Anfrage zur Prüfung senden möchten? Die Anfrage kann in der Prüfung nicht bearbeitet werden.",
    promoteRechargeError: "Beim Senden der Anfrage zur Prüfung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    createdRechargeConfirm: "Sind Sie sicher, dass Sie diese Anfrage auf den Status ERSTELLT setzen möchten?",
    createdRechargeError: "Beim Aktualisieren des Status der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    invoicedRechargeConfirm: "Sind Sie sicher, dass Sie diese Anfrage als Rechnungs gestellt markieren möchten?",
    invoicedRechargeError: "Beim Aktualisieren des Status der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    editStatusRechargeConfirm: "Sind Sie sicher, dass Sie den Status dieser Anfrage bearbeiten möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    editStatusRechargeError: "Beim Aktualisieren des Status der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    rejectRechargeConfirm: "Bitte geben Sie den Grund für die Ablehnung dieser Anfrage an.",
    rejectRechargeError: "Beim Ablehnen der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    scratchcardCreatedRechargeConfirm: "Sind Sie sicher, dass Sie diese Anfrage akzeptieren und bestätigen möchten, dass die Aufladekarte erstellt wurde?",
    scratchcardCreatedRechargeError: "Beim Akzeptieren der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    walletRechargedRechargeConfirm: "Sind Sie sicher, dass Sie diese Anfrage als abgeschlossen markieren und bestätigen möchten, dass das Wallet aufgeladen wurde?",
    walletRechargedRechargeError: "Beim Ändern des Status der Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    newFileName: "Bitte geben Sie den Dateinamen an",
    newFileExtensionError: "Die Datei hat eine nicht unterstützte Erweiterung",
    newFileDuplicateNameError: "Dieser Name wurde bereits für eine andere Datei verwendet. Ändern Sie den Namen und wiederholen Sie den Vorgang.",
    editCustrefConfirm: "Bitte geben Sie die Kunden-Referenz für diese Anfrage an.",
    editCustrefError: "Beim Aktualisieren der Kunden-Referenz ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
    editRecharge: "Wallet-Aufladung bearbeiten",
    newRecharge: "Neue Wallet-Aufladung",
    viewRecharge: "Wallet-Aufladung anzeigen",
    newRechargeError: "Beim Erstellen dieser Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    editRechargeError: "Beim Aktualisieren dieser Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut",
    exportRechargesCSV: "Datei exportieren",
    basicData: "Parameter der Wallet-Aufladung",
    ordersData: "Aufträge",
    invoiceData: "Rechnung",
    formEnterAnswer: "Ihre Antwort",
    formEnterAnswerGT0: "Zahl größer als 0",
    sfdcId: "Opportunity-ID (SFDC)",
    salesOrderConfirmationNumber: "Bestellbestätigungsnummer (Sell-out)",
    salesOrderConfirmationNumber_desc: "",
    selloutFiles: "Sell-out-Auftrag PDF (Hardware + Software + professionelle Dienstleistungen)",
    selloutFiles_desc: "Erforderlich, um die Blossom-Einnahmen korrekt zu verfolgen.",
    selloutFiles_desc2: "Dateibegrenzung: 5  ~  Maximale Dateigröße: 10MB  ~  Erlaubte Dateierweiterungen: ",
    selloutFilesAdd: "Datei hochladen",
    selloutFilesDownload: "Herunterladen",
    selloutFilesReplace: "Ersetzen",
    invoiceFile: "Rechnung PDF *",
    invoiceFile_desc: "Laden Sie die Rechnung im PDF-Format hoch.",
    invoiceFile_desc2: "Dateibegrenzung: 1  ~  Maximale Dateigröße: 10MB",
    invoiceNumber: "Rechnungsnummer (für den Endnutzer) *",
    purchaseOrderNumberSofia: "Bestellnummer an Sofia",
    orderContactEmail: "Kontakt-E-Mail der Bestellung"
  },
  vars: {
    varCategoryType: 'Typ',
    varCategoryType_VAR: 'VAR',
    varCategoryType_DEALER: 'Dealer',
    vashoManual: 'Partner-Handbuch',
    partnerLevel: 'Partner-Level',
    varEditSuccess: 'VAR erfolgreich aktualisiert',
    runningQuotations: 'Laufende Quotations',
    activeCustomers: 'Aktive Kunden',
    activeSystems: 'Aktive Systeme',
    monthlyCreditsBurnRate: 'Monatlicher Verbrauch an Credits',
    varHome: 'Home',
    candidatePartnerStepsAway: 'Sie müssen den Vertrag unterschreiben, um registrierter Partner zu werden',
    candidatePartnerStepsAwayDescription: 'Unterschreiben und senden Sie die VAR-Vereinbarung zurück, um einen registrierten Partner zu werden',
    registeredPartnerStepsAway: 'Du bist ein Schritt von einem registrierten Partner entfernt',
    registeredPartnerStepsAwayDescription: 'Unterschreiben und senden Sie die VAR-Vereinbarung zurück, um einen registrierten Partner zu werden',
    preferredPartner: 'Du bist als bevorzugter Partner klassifiziert!',
    preferredPartnerDescription: 'Du bist jetzt auf unserer Website als bevorzugter Partner sichtbar',
    preferredPartnerStepsAway: 'Du bist {{steps}} Schritte von einem bevorzugten Partner entfernt',
    preferredPartnerStepsAwayDescription: 'Um auf unserer Website als bevorzugter Partner sichtbar zu sein, musst du die verbleibenden Schritte abschließen',
    partnerLevelContractSigned: 'Vertrag unterschrieben',
    partnerLevelRebateLetterSigned: 'Rebate brief unterschrieben',
    partnerLevelTrainingCompleted: 'Training abgeschlossen',
    partnerLevelDemoKitPurchased: 'Demo-Kit erworben',
    partnerLevelQuotationRequested: 'Angebot angefordert',
    partnerLevelOneActiveCustomer: 'Ein aktiver Kunde',
    varDocumentHistoryRebateLetter: 'Dateistory',
    varDocumentHistoryAgreement: 'Dateistory',
    varDocumentHistoryDate: 'Ersetzungsdatum',
    syncsfdcidVarOpportunitySuccess: 'Anfrage übernommen. Bitte überprüfen Sie die entsprechende Angebotsinformation in Salesforce',
    varLogo: "Logo",
    setTrainingDate: "Schulungstermin festlegen",
    missingLastTrainingDateForCertificate: "Dieser VAR hat kein festgelegtes Schulungsdatum. Bitte legen Sie ein Schulungsdatum fest und versuchen Sie, das Zertifikat erneut zu generieren",
    expiredLastTrainingDateForCertificate: 'Dieser VAR\'s Schulung ist abgelaufen. Bitte aktualisieren Sie das Schulungsdatum und versuchen Sie, das Zertifikat erneut zu generieren',
    varLastTrainingData: "Letztes Schulungsdatum",
    varShortDescription: "Kurzbeschreibung",
    varLastTrainingDataExpirationDate: "Schulungsdauer ablaufen",
    rebateLetterFile: 'Rebate brief',
    varRebateLetterFileExpirationDate: 'Rebate brief ablaufen',
    varAgreementFileExpirationDate: 'Vertragsablauf',
    varDemoKitPurchaseDate: 'Demo-Kit-Erwerb',
    varDemoKitOrderNumber: 'Demo-Kit-Bestellnummer',
    varCity: "Stadt",
    varCountry: "Land",
    varWebsite: "Webseite",
    varVisibleOnSofiaWebsite: "Sichtbar auf der Partnerseite von Sofia",
    downloadCertificate: "Zertifikat herunterladen",
    opportunityChangeOwnerMessage: "Bitte geben Sie den Besitzer dieses Angebots an",
    noOpportunityHistoryFound: "Keine Angebots-Historie gefunden",
    noOpportunityHistoryFoundDescription: "Dieses Angebot hat keine Historieneinträge",
    customers: "Kunden",
    varsManagement: "VARs",
    varSettings: "Einstellungen",
    varInfoPage: "Schulung & Ressourcen",
    varUsersPage: "Benutzer",
    vars: "VAR",
    plantThemes: "Standort-Themen",
    editVarPersonalConfirm: "Sie sind dabei, Ihre Firmeninformationen zu bearbeiten. Sind Sie sicher, dass Sie fortfahren möchten?",
    editVarConfirm: "Sie sind dabei, die VAR-Daten zu bearbeiten. Sind Sie sicher, dass Sie fortfahren möchten?",
    editVar: "VAR bearbeiten",
    newVar: "Neuer VAR",
    varCreationConfirm: "Möchten Sie den neuen VAR erstellen?",
    createVar: "VAR erstellen",
    noVarFindTitle: "Kein VAR gefunden",
    noVarFindDescription: "Die VAR-Liste ist leer. Falls ein Suchfilter gesetzt wurde, versuchen Sie diesen zurückzusetzen und erneut zu suchen",
    noPlantThemeFindTitle: "Kein Standort-Thema gefunden",
    noPlantThemeFindDescription: "Die Standort-Themen-Liste ist leer. Falls ein Suchfilter gesetzt wurde, versuchen Sie diesen zurückzusetzen und erneut zu suchen",
    clusterSelection: "Jeder Cluster",
    varSelection: "Jeder VAR",
    varName: "Name",
    varAddress: "Adresse",
    varEmail: "Primäre Kontakt-E-Mail",
    varPhone: "Telefon",
    varCluster: "Cluster",
    varVat: "USt.",
    varTechContact: "Technischer Kontakt",
    varCommercialContact: "Kaufmännischer Kontakt",
    varNameTech: "Name des technischen Kontakts",
    varEmailTech: "E-Mail des technischen Kontakts",
    varPhoneTech: "Telefon des technischen Kontakts",
    varNameComm: "Name des kaufmännischen Kontakts",
    varEmailComm: "E-Mail des kaufmännischen Kontakts",
    varPhoneComm: "Telefon des kaufmännischen Kontakts",
    varSfdcid: "SFDC ACCOUNT ID",
    varSupportEmail: "Support-E-Mail",
    varSupportHours: "Support-Öffnungszeiten",
    varCompanyName: "Firmenname",
    varCustomers: "VAR-Endnutzer",
    varUsers: "VAR-Benutzer",
    varOpportunities: "VAR-Angebote",
    editPlantThemeConfirm: "Sie sind dabei, die Daten des Standort-Themas zu bearbeiten. Sind Sie sicher, dass Sie fortfahren möchten?",
    editPlantTheme: "Standort-Thema bearbeiten",
    newPlantTheme: "Neues Standort-Thema",
    plantThemeCreationConfirm: "Möchten Sie das neue Standort-Thema erstellen?",
    editVarPersonal: "Firmeninformationen bearbeiten",
    plantThemeName: "Name",
    plantThemeColour: "Farbe *",
    plantThemeColourDescription: "Themenfarbe",
    plantThemeLogo: "Logo",
    plantThemeDefault: "Als Standardthema verwenden",
    logoFile: "Logo-Bild *",
    logoFile_desc: "Erlaubte Dateierweiterungen: ",
    logoFileAdd: "Datei hochladen",
    logoFileDownload: "Herunterladen",
    logoFileReplace: "Ersetzen",
    deletePlantThemeConfirm: "Sind Sie sicher, dass Sie dieses Standort-Thema löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    plantThemeSearchEnterName: "Thema auswählen",
    plantThemeSearch: "Wählen Sie das gewünschte Thema aus",
    domainThemeTitle: "Benutzerdefiniertes Domain-Thema",
    domainThemeDescription: "Legen Sie Ihr benutzerdefiniertes Thema für diese Domain fest",
    plantThemeModifySuccess: "Standort-Thema erfolgreich geändert und aktualisiert",
    cannotDeleteAssociatedTheme: "Ein mit einem Standort verknüpftes Thema kann nicht gelöscht werden.",
    plantThemeAssociatedPlants: "Standorte, die mit diesem Thema verknüpft sind",
    newVarUser: "Neuer VAR-Benutzer",
    varUserCreationConfirm: "Möchten Sie den neuen VAR-Benutzer erstellen?",
    createVarUser: "VAR-Benutzer erstellen",
    varUserFormTitle: "VAR-Benutzer",
    createNewVarUser: "Neuen VAR-Benutzer erstellen",
    noVarUserFindTitle: "Keine VAR-Benutzer gefunden",
    noVarUserFindDescription: "Die VAR-Benutzerliste ist leer",
    deleteVarUserConfirm: "Sind Sie sicher, dass Sie diesen VAR-Benutzer löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    deleteVarOpportunityConfirm: "Sind Sie sicher, dass Sie dieses Angebot löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    rejectVarOpportunityConfirm: "Sind Sie sicher, dass Sie dieses Angebot ablehnen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    approveVarOpportunityConfirm: "Sind Sie sicher, dass Sie dieses Angebot genehmigen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    syncsfdcidVarOpportunityConfirm: "Sind Sie sicher, dass Sie diesem Angebot eine SFDC-ID zuweisen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    upgradeVarOpportunityConfirm: "Sind Sie sicher, dass Sie dieses Angebot zur Überarbeitung senden möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    winVarOpportunityConfirm: "Sind Sie sicher, dass Sie dieses Angebot als GEWONNEN markieren möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    lostVarOpportunityConfirm: "Sind Sie sicher, dass Sie dieses Angebot als VERLOREN markieren möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    deleteUserConfirm: "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden",
    varUserUsername: "Benutzername",
    varUserFirstname: "Vorname",
    varUserLastname: "Nachname",
    varUserEmail: "E-Mail",
    varUsersList: "Benutzer",
    newFileExtensionError: "Die Datei hat eine nicht unterstützte Erweiterung",
    agreementFile: "Vertrag",
    opportunities: "Angebote",
    opportunityManagement: "Angebotsinformationen",
    opportunityID: "ID",
    opportunityOpty: "SFDC OPTY ID",
    opportunityVar: "VAR",
    opportunityCustomer: "Endnutzer",
    opportunityOwner: "Angebotsbesitzer",
    opportunityName: "Angebotsname",
    opportunityValue: "Wert",
    opportunityStatus: "Status",
    opportunityActions: "Aktionen",
    opportunityDescription: "Beschreibung",
    opportunityNotes: "Notizen",
    opportunityCrm: "CRM",
    noOpportunityFindTitle: "Keine Angebote gefunden",
    noOpportunityFindDescription: "Die Angebotsliste ist leer",
    opportunityStatus_DRAFT: "Entwurf",
    opportunityStatus_ON_APPROVAL: "In Überprüfung",
    opportunityStatus_APPROVED: "Genehmigt",
    opportunityStatus_CANCELLED: "Abgebrochen",
    opportunityStatus_REJECTED: "Abgelehnt",
    opportunityStatus_WON: "Gewonnen",
    opportunityStatus_LOST: "Verloren",
    opportunityFiles: "Anhänge",
    newOpportunity: "Neues Angebot",
    editOpportunity: "Angebot bearbeiten",
    opportunitySyncSFDC: "Mit SFDC synchronisieren",
    exportOpportunities: "CSV exportieren",
    upgradeOpportunity: "Zur Überprüfung senden",
    approveOpportunity: "Genehmigen",
    rejectOpportunity: "Ablehnen",
    wonOpportunity: "Als GEWONNEN markieren",
    lostOpportunity: "Als VERLOREN markieren",
    CREATED: "Angebot erstellt",
    VAR_USER_UPDATED: "VAR-Benutzer des Angebots aktualisiert",
    DESCRIPTION_UPDATED: "Angebotsbeschreibung aktualisiert",
    NAME_UPDATED: "Angebotsname aktualisiert",
    VALUE_UPDATED: "Angebotswert aktualisiert",
    CURRENCY_UPDATED: "Angebotswährung aktualisiert",
    OPTY_ID_UPDATED: "Angebot Opty ID aktualisiert",
    ISEO_CRM_ID_UPDATED: "Angebot SFDC ID aktualisiert",
    DOCUMENTS_UPDATED: "Angebotsdokumente aktualisiert",
    STATUS_ON_APPROVAL: "Angebot zur Genehmigung gesendet",
    STATUS_APPROVED: "Angebot genehmigt",
    STATUS_WON: "Angebot als gewonnen markiert",
    STATUS_LOST: "Angebot als verloren markiert",
    STATUS_DRAFT: "Angebot als Entwurf markiert",
    STATUS_CANCELLED: "Angebot als abgebrochen markiert",
    CANCELLED: "Angebot abgebrochen",
    STATUS_REJECTED: "Angebot als abgelehnt markiert",
    showOpportunityHistory: "Historie anzeigen",
    opportunityHistory: "Angebotshistorie"
  },
  save: "Speichern",
  languages: {
    it: "Italienisch",
    en: "Englisch",
    de: "Deutsch",
    fr: "Französisch",
    es: "Spanisch",
    nl: "Niederländisch",
    ITALIAN: "Italienisch",
    ENGLISH: "Englisch",
    GERMAN: "Deutsch",
    FRENCH: "Französisch",
    SPANISH: "Spanisch",
    DUTCH: "Niederländisch",
    menuHeading: "Sprache auswählen"
  },
  productInfo: {
    software: "Software",
    salesMaterial: "Verkaufsmaterial",
    hardware: "Hardware",
    marketingMaterial: "Marketingmaterial"
  },
  users: {
    usersManagement: "Benutzerverwaltung",
    users: "Benutzer",
    noUserFindTitle: "Keine Benutzer gefunden",
    noUserFindDescription: "Die Benutzerliste ist leer. Versuchen Sie, Ihre Suchfilter zurückzusetzen, falls vorhanden",
    search: "Suchen...",
    roleSelection: "Rolle",
    clusterSelection: "Cluster",
    varSelection: "VAR",
    newUser: "Hinzufügen",
    userFirstname: "Vorname",
    userLastname: "Nachname",
    userEmail: "E-Mail",
    userFormTitle: "Benutzerdaten",
    editUserForm: "Benutzer bearbeiten",
    newUserForm: "Benutzer erstellen"
  },
  permissions: {
    CSV_IMPORT: 'Importe von Master Key Systemen verwalten',
    CREATE_REQUEST: 'Anfragen erstellen',
    MANAGE_REQUEST: 'Anfragen verwalten',
    EXPORT_REQUESTS: 'Anfragen exportieren',
    MKS: 'Gestaltung von Master Key Systemen',
    SEARCH_BY_DOMAIN: 'Nach Domain suchen',
    SELLOUT_GENERATED: 'Sellout generiert',
    INVOICED: 'Invoziert',
    MARK_UNDER_REVIEW: 'Entität als in Überprüfung markieren',
    NAVIGATION: "Menü-Sichtbarkeit",
    CLUSTER: "Cluster",
    VAR: "VAR",
    CUSTOMER: "Endnutzer",
    OPPORTUNITY: "Angebote",
    WALLET: "Endnutzer-Wallets",
    DOMAIN: "Endnutzer-Systeme",
    GATEWAYS: "Gateway",
    CARD: "Aufladekarten",
    PLANT_ACTIVATION: "Systemaktivierungen",
    RECHARGE_REQUEST: "System-Aufladungen",
    ACTIVATION_REQUEST: "Aktivierungsanfragen",
    EXPORT: "Entitäten exportieren",
    CREATE: "Neue Entität erstellen",
    UPDATE: "Entität aktualisieren",
    MARK_LOST: "Entität als verloren markieren",
    MARK_WON: "Entität als gewonnen markieren",
    CANCEL: "Entität als storniert markieren",
    CANCEL_DRAFT: "Entität als storniert markieren, wenn es sich um einen Entwurf handelt",
    CANCEL_ON_APPROVAL: "Entität als storniert markieren, wenn sie in der Prüfung ist",
    CANCEL_APPROVED: "Entität als storniert markieren, wenn sie genehmigt ist",
    MARK_TO_BE_APPROVED: "Entität zur Genehmigung markieren",
    RECHARGE: "Aufladen",
    SUBSCRIPTION_UPDATE: "Abonnements aktualisieren",
    DELETE_REQUEST: "Löschanfrage senden",
    CREATION_REQUEST: "Anfrage zur Erstellung einer neuen Entität senden",
    MANAGER_CREATE: "Administratoren erstellen",
    MANAGER_UPDATE: "Administratoren aktualisieren",
    INSTALLER_CREATE: "Installer erstellen",
    INSTALLER_UPDATE: "Installer aktualisieren",
    IMPERSONATE_WRITE: "Administratoren imitieren",
    IMPERSONATE_SUPPORT: "Support-Konto imitieren",
    ADDITIONAL_INFO_UPDATE: "Zusätzliche Informationen bearbeiten",
    CUSTOMERS: "Endnutzer",
    PLANT_ACTIVATIONS: "Systemaktivierungen",
    RECHARGE_REQUESTS: "System-Aufladungen",
    ACTIVATION_REQUESTS: "Aktivierungsanfragen",
    CARDS: "Aufladekarten",
    VAR_USERS: "VAR-Benutzer",
    VAR_SETTINGS: "VAR-Einstellungen",
    OPPORTUNITIES: "Angebote",
    PRODUCTINFO: "Produktinformationen",
    USER_READ: "Benutzer anzeigen",
    USER_UPDATE: "Benutzer aktualisieren",
    USER_CREATE: "Neuen Benutzer erstellen",
    PLANT_THEME: "Domain-Thema ändern",
    READ: "Entitätswerte lesen",
    ORDERS_STATUS: "Auftragsstatus",
    FILTER: "Entitäten filtern",
    VAR_MANAGEMENT: "VAR-Verwaltung",
    MARKETPLACES: "Marktplätze",
    DOMAINS: "Endnutzer-Systeme",
    PRICELIST: "Preisliste",
    SALESINFO: "Verkaufsinformationen",
    PLATFORM_USERS: "Benutzerverwaltung",
    APPROVE: "Entität als genehmigt markieren",
    REJECT: "Entität als abgelehnt markieren",
    EXTEND: "Erweitern",
    CONFIG: "Entitätskonfigurationen lesen",
    IRIS_ENABLE: "1RIS für die Domain aktivieren",
    MARK_TO_PROMOTE: "Entität zur Förderung markieren",
    MARK_TO_INVOCE: "Entität zur Rechnungsstellung markieren",
    DELETE: "Entitäten löschen",
    EDIT: "Entitäten bearbeiten",
    SUBSCRIPTION_DELETE: "Abonnements löschen",
    VAR_HOMEPAGE: 'VAR-Homepage',
    CHANGE_OWNER: 'Besitzer ändern',
    CONTRACTS: 'Verträge',
    CONTRACT_SERVICES: 'Vertragsdienstleistungen',
    DOWNLOAD_CERTIFICATE: 'Zertifikat herunterladen',
    PLANTS_READ: 'Systeme lesen',
    PLANTS_UPDATE: 'Systeme aktualisieren',
    PLANTS_CREATE: 'Systeme erstellen',
    PLANTS_DELETE: 'Systeme löschen',
    SYNC_SFDCID: 'Mit SFDC synchronisieren',
    UPDATE_ADMIN: 'Administratoren aktualisieren',
    HISTORY_READ: 'Historie lesen',
    UPDATE_LOGO: 'Logo aktualisieren',
    EXPORT_ALL_MANAGERS: 'Alle Administratoren exportieren',
    LEGACY_DOMAINS_READ: 'Legacy-Domains lesen',
    TAKE_CHARGE: 'In Anspruch nehmen',
    EDIT_ADMIN: 'Administratoren bearbeiten',
    DEMO_READ: 'Demo-Systeme lesen',
    DEMO_CREATE: 'Demo-Systeme erstellen',
    DEMO_UPDATE: 'Demo-Systeme aktualisieren',
    DEMO_DELETE: 'Demo-Systeme löschen',
    DEMO_MANAGEMENT: 'Demo-Systeme verwalten',
  },
  segmentTypes: {
    WORKING_SPACES_name: "Flexibler Arbeitsbereich",
    LIVING_name: "Flexibles Wohnen",
    RETAIL_name: "Flexibler Einzelhandel",
    UNIVERSITIES_name: "Universitäten",
    LEISURE_name: "Freizeit und Gastgewerbe",
    HOSPITAL_name: "Krankenhaus",
    WORKING_SPACES_description: "Büros, Coworking, Business Center",
    LIVING_description: "Wohnung, Co-Housing, Co-Living, Studentenwohnheim",
    RETAIL_description: "Multistandort Einzelhandel, Einkaufszentren, Ladenketten",
    LEISURE_description: "Kleine und mittelgroße Hotels, Unterkünfte, Sportzentren",
    HOSPITAL_description: "Krankenhäuser, Seniorenresidenzen und Altenpflege",
    deprecated: 'OLD',
    ESTATE_WORKPLACES_REAAS_name: 'Estate - Workplaces - ReaaS [Coworking, Proworking, Business Centers]',
    ESTATE_WORKPLACES_BTR_name: 'Estate - Workplaces - BTR [Single company offices, Hybrid Workplaces, Multi-tenant office buildings, Business Parks]',
    ESTATE_RESIDENTIAL_REAAS_name: 'Estate - Residential - ReaaS [Coliving, Student housing (PBSA), Senior Housing]',
    ESTATE_RESIDENTIAL_BTR_name: 'Estate - Residential - BTR [Multifamily housing, Condos]',
    ESTATE_RESIDENTIAL_BTS_name: 'Estate - Residential - BTS [Multifamily housing, Condos, Cohousing]',
    ESTATE_EDUCATION_name: 'Estate - Education [Schools, Universities]',
    ESTATE_SPORT_FACILITIES_name: 'Estate - Sport Facilities [Arenas, Football stadiums, Tennis courts]',
    ESTATE_MUNICIPALITIES_name: 'Estate - Municipalities [Townhalls, Public Offices]',
    ESTATE_HEALTHCARE_name: 'Estate - Healthcare [Hospitals, Elderly care facilities]',
    ESTATE_RETAIL_MULTI_SITE_name: 'Estate - Retail - Multi site [Pharmacies, Postal Offices, Banks, DIY stores, Fashion, Private clinics]',
    ESTATE_HOSPITALITY_PROFESSIONAL_name: 'Estate - Hospitality - Professional [Big hotels]',
    ESTATE_HOSPITALITY_SMALL_name: 'Estate - Hospitality - Small [Small Hotels, B&Bs, Camping sites]',
    UTILITIES_TELECOM_name: 'Utilities - Telecom [Infrastructure, Operartors]',
    UTILITIES_ELECTRICITY_name: 'Utilities - Electricity [Production, Distribution]',
    'UTILITIES_OIL&GAS_name': 'Utilities - Oil&Gas [Pipes, Transportation]',
    UTILITIES_WATER_name: 'Utilities - Water [Purification, Distribution, Wastewater treatment]',
    UTILITIES_WASTE_name: 'Utilities - Waste [Bio Hazard]',
    UTILITIES_TRANSPORTATION_name: 'Utilities - Transportation [Railways, Subway, Roads, Airports]',
    DEMO_name: 'Demo',
  },
  demoSystem: {
    title: 'Meine Demo-Systeme',
    name: 'Name',
    notes: 'Notizen',
    url: 'URL',
    peopleUsing: 'Personen, die dieses Demo nutzen',
    openNow: 'Jetzt öffnen',
    noDataTitle: 'Keine Demo-Systeme gefunden',
    noDataDescription: 'Es gibt keine Demo-Systeme verfügbar momentan',
    newDemoPlantAssociation: 'Demo-System zuweisen',
    demoPlantAssociationCompleted: 'Demo-System erfolgreich zugewiesen',
    createDemoPlantAssociationError: 'Ein Fehler ist aufgetreten, während das Demo-System zugewiesen wurde. Bitte versuchen Sie es erneut',
    deleteDemoPlantAssociation: 'Sind Sie sicher, dass Sie diese Demo-System-Zuweisung löschen möchten?',
    deleteDemoPlantAssociationConfirm: 'Demo-System-Zuweisung erfolgreich gelöscht',
    deleteDemoPlantAssociationError: 'Ein Fehler ist aufgetreten, während die Demo-System-Zuweisung gelöscht wurde. Bitte versuchen Sie es erneut',
    demoPlantAssociationEditedCompleted: 'Demo-System-Zuweisung erfolgreich bearbeitet',
    editDemoPlantAssociationError: 'Ein Fehler ist aufgetreten, während die Demo-System-Zuweisung bearbeitet wurde. Bitte versuchen Sie es erneut',
    demoSystemsTitle: 'Demo-Systeme',
  },
  agreements: {
    privacyPolicy: 'Datenschutzrichtlinie',
    termsAndConditions: 'Allgemeine Geschäftsbedingungen',
    acceptAgreements: 'Akzeptieren',
    agreementsUpdated: 'Vereinbarungen Aktualisiert',
    pleaseAcceptAgreements: 'Bitte akzeptieren Sie die aktualisierten Vereinbarungen, um fortzufahren',
    errorAcceptTermsAndPrivacy: 'Fehler beim Akzeptieren der Bedingungen und der Datenschutzrichtlinie',
  },
  mks: {
    yourRoleDoesNotHavePermissionToImportCsv: 'Ihre Rolle hat keine Berechtigung, MKS CSV-Dateien zu importieren. Bitte überprüfen Sie Ihre Berechtigungen und versuchen Sie es erneut.',
    status_COMPLETED: 'Vorherige',
    status_CURRENT: 'Aktuelle',
    status_ERROR: 'Fehler',
    requestType: 'Anfragetyp',
    selectFileFormat: 'Dateiformat auswählen',
    importFileFormat_LOCKBASE: 'Lockbase',
    importFileFormat_SUPERLOCK: 'Superlock',
    importFileFormat: 'Import-Dateiformat',
    mksTitle: 'Master Key Systems',
    cylindersTitle: 'Zylinder',
    keyDetails: 'Schlüsseldetails',
    cylinderDetails: 'Zylinderdetails',
    hostnameRequiredForImportDescription: 'Bitte geben Sie einen Anlagenname ein, um die Daten zu importieren',
    keysTitle: 'Schlüssel',
    id: 'ID',
    externalId: 'Externe ID',
    doorName: 'Türname',
    marking: 'Markierung',
    type: 'Typ',
    insideLength: 'Innenlänge',
    outsideLength: 'Außenlänge',
    quantity: 'Menge',
    quantityKeys: 'Schlüsselmenge',
    keyFunction: 'Schlüsselfunktion',
    designation: 'Bezeichnung',
    companyId: 'Unternehmens-ID',
    hostnameRequired: 'Anlagenname (erforderlich)',
    hostnameRequiredTitle: 'Anlage Erforderlich',
    hostnameRequiredDescription: 'Bitte geben Sie einen Anlagenname ein, um die Liste anzuzeigen',
    noCylindersFoundTitle: 'Keine Zylinder Gefunden',
    noCylindersFoundDescription: 'Für die angegebene Anlage wurden keine Zylinder gefunden',
    noKeysFoundTitle: 'Keine Schlüssel Gefunden',
    noKeysFoundDescription: 'Für die angegebene Anlage wurden keine Schlüssel gefunden',
    filterByType: 'Zylindertyp',
    filterByDoorName: 'Türname',
    filterByKeyFunction: 'Schlüsselfunktion',
    filterByDesignation: 'Schlüsselbezeichnung',
    importsTitle: 'Importe',
    noImportsFoundTitle: 'Keine Importe Gefunden',
    noImportsFoundDescription: 'Für die angegebene Anlage wurden keine Importe gefunden',
    filterByStatus: 'Importstatus',
    filterByFilename: 'Dateiname',
    uploadCsv: 'Datei Hochladen',
    uploadCsvTitle: 'Datei Hochladen',
    dragDropCsv: 'Ziehen Sie Ihre Datei hierher',
    orClickToSelect: 'oder klicken Sie, um eine Datei auszuwählen',
    previewCsv: 'Vorschau',
    csvPreviewTitle: 'Import-Vorschau',
    previewSummary: 'Import-Zusammenfassung',
    csvHasErrors: 'Die Datei enthält Validierungsfehler. Nur gültige Zeilen werden importiert.',
    validationErrors: 'Validierungsfehler',
    dataPreview: 'Datenvorschau',
    noValidRowsToImport: 'Keine gültigen Zeilen für den Import gefunden. Bitte korrigieren Sie die Fehler und versuchen Sie es erneut.',
    confirmImport: 'Import Bestätigen',
    fileInfo: 'Dateiinformationen',
    importSummary: 'Import-Zusammenfassung',
    filename: 'Dateiname',
    importTimestamp: 'Importdatum',
    status: 'Status',
    keysImported: 'Importierte Schlüssel',
    cylindersImported: 'Importierte Zylinder',
    relationsImported: 'Importierte Beziehungen',
    errorsCount: 'Fehleranzahl',
    userEmail: 'Benutzer-E-Mail',
    noKeySelected: 'Kein Schlüssel ausgewählt',
    noCylinderSelected: 'Kein Zylinder ausgewählt',
    customAttributes: 'Benutzerdefinierte Attribute',
    associatedCylinders: 'Zugehörige Zylinder',
    associatedKeys: 'Zugehörige Schlüssel',
    noAssociatedCylinders: 'Keine zugehörigen Zylinder gefunden',
    noAssociatedKeys: 'Keine zugehörigen Schlüssel gefunden',
    relationId: 'Beziehungs-ID',
    fileSize: 'Dateigröße',
    totalRows: 'Gesamtzeilen',
    errors: 'Fehler',
    keys: 'Schlüssel',
    cylinders: 'Zylinder',
    relations: 'Beziehungen',
    currentConfig: 'Aktuelle Konfiguration',
    confirmImportTitle: 'Import Bestätigen',
    confirmImportMessage: 'Sind Sie sicher, dass Sie diese Datei importieren möchten?',
    fileName: 'Dateiname',
    warningMessage: 'WARNUNG: Diese Operation wird die aktuelle Anlagenkonfiguration vollständig mit den Daten aus dieser CSV-Datei überschreiben. Diese Operation ist nicht reversibel.',
    comparisonTitle: 'Vergleich mit der Aktuellen Konfiguration',
    currentLabel: 'Aktuell',
    newLabel: 'Neu',
    requestsTitle: 'MKS-Anfragen',
    newRequest: 'Neue Anfrage',
    editRequest: 'Anfrage Bearbeiten',
    requestManagement: 'Anfragenverwaltung',
    requestType_KEY_DUPLICATION: 'Schlüsselduplikation',
    requestType_CYLINDER_DUPLICATION: 'Zylinderduplikation',
    requestType_KEY_EXTENSION: 'Schlüsselextension',
    requestType_CYLINDER_EXTENSION: 'Zylinderextension',
    requestStatus: 'Status',
    requestStatus_DRAFT: 'Entwurf',
    requestStatus_SENT: 'Gesendet',
    requestStatus_TAKEN_IN_CHARGE: 'Übernommen',
    requestStatus_REJECTED: 'Abgelehnt',
    requestStatus_CANCELED: 'Storniert',
    requestStatus_ORDER_CONFIRMED: 'Bestellung Bestätigt',
    requestStatus_ORDER_SHIPPED: 'Bestellung Versendet',
    requestStatus_ORDER_COMPLETED: 'Bestellung Abgeschlossen',
    historyAction_CREATED: 'Erstellt',
    historyAction_UPDATED: 'Aktualisiert',
    historyAction_STATUS_CHANGED: 'Status Geändert',
    historyAction_STATUS_DRAFT: 'Status Entwurf',
    historyAction_STATUS_SENT: 'Status Gesendet',
    historyAction_STATUS_TAKEN_IN_CHARGE: 'Status Übernommen',
    historyAction_STATUS_REJECTED: 'Status Abgelehnt',
    historyAction_STATUS_ORDER_CONFIRMED: 'Status Bestellung Bestätigt',
    historyAction_STATUS_ORDER_SHIPPED: 'Status Bestellung Versendet',
    historyAction_STATUS_ORDER_COMPLETED: 'Status Bestellung Abgeschlossen',
    historyAction_STATUS_CANCELED: 'Status Storniert',
    historyAction_NOTES_UPDATED: 'Notizen Aktualisiert',
    historyAction_DELIVERY_DATE_UPDATED: 'Lieferdatum Aktualisiert',
    historyAction_DOCUMENTS_ADDED: 'Dokumente Hinzugefügt',
    historyAction_DOCUMENTS_REMOVED: 'Dokumente Entfernt',
    historyAction_CANCELLED: 'Storniert',
    historyAction_COMPLETED: 'Abgeschlossen',
    requestNotes: 'Notizen',
    requestData: 'Anfragedaten (JSON)',
    plantHostname: 'Anlagen-Hostname',
    companyName: 'Unternehmen',
    createdBy: 'Erstellt Von',
    deliveryDate: 'Lieferdatum',
    plantSearch: 'Anlage Suchen',
    plantSearchNoMatch: 'Keine Anlagen gefunden',
    plantSearchEnterName: 'Hostname eingeben zum Suchen',
    selectRequestType: 'Anfragetyp Auswählen',
    requestTypeFilter: 'Nach Typ Filtern',
    statusFilter: 'Nach Status Filtern',
    sendRequest: 'Anfrage Senden',
    takeInCharge: 'Übernehmen',
    rejectRequest: 'Ablehnen',
    confirmOrder: 'Bestellung Bestätigen',
    shipOrder: 'Bestellung Versenden',
    completeOrder: 'Bestellung Abschließen',
    deleteMKSRequestConfirm: 'Sind Sie sicher, dass Sie diese Anfrage stornieren möchten?',
    changeStatusMKSRequestConfirm: 'Sind Sie sicher, dass Sie den Status dieser Anfrage ändern möchten?',
    requestHistory: 'Anfragehistorie',
    noRequestHistoryFound: 'Keine Historie Gefunden',
    noRequestHistoryFoundDescription: 'Keine Historieeinträge für diese Anfrage gefunden',
    noRequestFindTitle: 'Keine Anfragen Gefunden',
    noRequestFindDescription: 'Keine MKS-Anfragen gefunden. Versuchen Sie, Ihre Suchfilter anzupassen.',
    exportRequests: 'Anfragen Exportieren',
    createMKSRequestConfirm: 'Sind Sie sicher, dass Sie diese neue MKS-Anfrage erstellen möchten?',
    editMKSRequestConfirm: 'Sind Sie sicher, dass Sie diese MKS-Anfrage bearbeiten möchten?',
    openMKSRequestsError: 'Ein Fehler ist beim Laden der MKS-Anfragen aufgetreten. Bitte versuchen Sie es erneut',
    createMKSRequestError: 'Ein Fehler ist beim Erstellen der Anfrage aufgetreten. Bitte versuchen Sie es erneut',
    editMKSRequestError: 'Ein Fehler ist beim Aktualisieren der Anfrage aufgetreten. Bitte versuchen Sie es erneut',
    deleteMKSRequestError: 'Ein Fehler ist beim Stornieren der Anfrage aufgetreten. Bitte versuchen Sie es erneut',
    changeMKSRequestStatusError: 'Ein Fehler ist beim Ändern des Anfragestatus aufgetreten. Bitte versuchen Sie es erneut',
    seePlant: 'Anlage Anzeigen',
    customerName: 'Kundenname',
    varName: 'VAR-Name',
    length: 'Länge',
    cylindersList: 'Zylinderliste',
    cylindersData: 'Zylinderdaten (JSON)',
    keysList: 'Schlüsselliste',
    keysData: 'Schlüsseldaten (JSON)',
    assignedUser: 'Zugewiesener Benutzer',
    selectAssignedUser: 'Zugewiesenen Benutzer Auswählen',
    selectCylinders: 'Zylinder Auswählen',
    selectKeys: 'Schlüssel Auswählen',
    requestFiles: 'Anfrage-Dateien',
    rejectedNotes: 'Ablehnungsnotizen',
    setDeliveryDateConfirm: 'Bitte setzen Sie das Lieferdatum für diese Bestellung',
    editDeliveryDate: 'Lieferdatum Bearbeiten',
    editDeliveryDateConfirm: 'Bitte aktualisieren Sie das Lieferdatum für diese Bestellung',
    saveRequestConfirmation: 'Anfrage Speichern',
    saveRequestConfirmationMessage: 'Möchten Sie die Anfrage als Entwurf speichern oder jetzt senden?',
    saveRequestConfirmationConfirm: 'Jetzt Senden',
    saveRequestConfirmationCancel: 'Als Entwurf Speichern',
    createDuplicateKeyRequest: 'Schlüssel-Duplikat-Anfrage Erstellen',
    createDuplicateCylinderRequest: 'Zylinder-Duplikat-Anfrage Erstellen',
    selectCylinder: 'Zylinder Auswählen',
    selectKey: 'Schlüssel Auswählen',
    relationsMatrixTitle: 'Beziehungsmatrix',
    cylinderName: 'Zylindername',
    noRelationsFoundTitle: 'Keine Beziehungen Gefunden',
    noRelationsFoundDescription: 'Keine Zylinder-Schlüssel-Beziehungen für die angegebene Anlage gefunden',
    selectedKey: 'Ausgewählter Schlüssel',
    selectedCylinder: 'Ausgewählter Zylinder',
    selectedKeys: 'Ausgewählte Schlüssel',
    plantSearchPlaceholder: 'Ein System suchen',
    keysDuplicates: 'Schlüssel Duplikate',
    cylindersDuplicates: 'Zylinder Duplikate',
    addKey: 'Schlüssel Hinzufügen',
    addCylinder: 'Zylinder Hinzufügen',
    duplicateEntry: 'Duplikat Eintrag',
    duplicateKey: 'Schlüssel Duplikat',
    duplicateCylinder: 'Zylinder Duplikat',
    noKeysSelected: 'Keine Schlüssel ausgewählt',
    noCylindersSelected: 'Keine Zylinder ausgewählt',
    quantityError: 'Die Menge muss eine ganze Zahl größer als null sein',
    batchAdd: 'Stapel Hinzufügen',
    batchAddTitleCylinders: 'Zylinder Stapel Hinzufügen',
    batchAddTitleKeys: 'Schlüssel Stapel Hinzufügen',
    batchAddFilterCylinders: 'Zylinder filtern',
    batchAddFilterKeys: 'Schlüssel filtern',
    batchAddConfirm: 'Bestätigen',
    batchAddCancel: 'Abbrechen',
    batchAddNoResults: 'Keine Elemente gefunden',
    batchAddTooManyResults: 'Zu viele Ergebnisse (mehr als {{limit}}). Bitte verfeinern Sie Ihren Suchfilter.',
    alreadySelected: 'Bereits ausgewählt',
    openAdvancedSelector: 'Erweiterten Auswähler öffnen',
    selectCylindersWithCount: 'Zylinder auswählen ({{count}})',
    selectKeysWithCount: 'Schlüssel auswählen ({{count}})',
    selectedItemsCount: '{{count}} Elemente ausgewählt',
    itemsWillBeAdded: '{{count}} Elemente werden hinzugefügt',
    addItems: 'Elemente Hinzufügen ({{count}})',
    generatePdf: 'PDF generieren',
    requestPdf: 'Anfrage PDF',
    pdfGenerationError: 'Beim Generieren des PDFs ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut',
    generateXlsx: 'Excel generieren',
    xlsxGenerationError: 'Beim Generieren der Excel-Datei ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut',
    generateDocx: 'Word generieren',
    docxGenerationError: 'Beim Generieren des Word-Dokuments ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut',
    exportRequest: 'Anfrage exportieren',
    field: 'Feld',
    value: 'Wert',
  },
  developers: {
    integrationInfo: 'Integration-Informationen',
    api: 'API',
    sdk: 'SDK',
    knx: 'KNX',
    developersResource: 'Entwickler-Ressourcen',
  },
  iseo: {
    trainingMaterials: 'ISEO Schulungsmaterialien',
  },
  iseoSalesApps: {
    launchpadMissingToken: 'Vasho-Sitzungstoken konnte nicht gelesen werden. Melden Sie sich erneut an und öffnen Sie Sales Apps über das Menü.',
    missingBaseUrl: 'Sales-Apps-Basis-URL ist nicht konfiguriert. Legen Sie sie in Vasho Settings fest.',
  },
  settings: {
    title: 'Einstellungen',
    salesAppVersion: 'Sales Apps Version',
    salesAppVersionDescription: 'Help-center-Basis-URL (z. B. …/sales-apps/v122) oder Launchpad (z. B. …/launchpad).',
    save: 'Speichern',
    saveSuccess: 'Einstellungen erfolgreich gespeichert',
    saveError: 'Einstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut',
    invalidValue: 'Bitte geben Sie eine gültige Ganzzahl ein',
  },
};

export default translations;